import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Decimal: { input: any; output: any; }
};

export type AccessDataInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AccessField = {
  __typename?: 'AccessField';
  field: Field;
  key: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  postal?: Maybe<Scalars['String']['output']>;
  subdivision?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type Answer = {
  __typename?: 'Answer';
  answerId: Scalars['ID']['output'];
  fieldId: Scalars['ID']['output'];
  fileType?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  questionId: Scalars['ID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type AnswerInput = {
  answerId?: InputMaybe<Scalars['ID']['input']>;
  fieldId: Scalars['ID']['input'];
  fileType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  questionId: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  contentUri: Scalars['String']['output'];
  downloadUri: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  friendlyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isImage: Scalars['Boolean']['output'];
  isPdf: Scalars['Boolean']['output'];
  isPrimary: Scalars['Boolean']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  printUri: Scalars['String']['output'];
  readableFileSize?: Maybe<Scalars['String']['output']>;
  sizeInBytes?: Maybe<Scalars['Float']['output']>;
  thumbnailUri: Scalars['String']['output'];
};

export type Attendee = {
  __typename?: 'Attendee';
  attachmentFileType?: Maybe<Scalars['String']['output']>;
  attachmentId?: Maybe<Scalars['ID']['output']>;
  attendeeAnswers: Array<Answer>;
  attendeeId: Scalars['ID']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  integratedDataOnFile?: Maybe<Array<Answer>>;
  lastName?: Maybe<Scalars['String']['output']>;
  manualPermissionDate?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  originalValueUri?: Maybe<Scalars['String']['output']>;
  permitted?: Maybe<Scalars['Boolean']['output']>;
  responseAttendeeId: Scalars['ID']['output'];
  tickets: Array<PurchasedTicket>;
};

export type AttendeeInput = {
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  manualPermissionDate?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  permitted?: InputMaybe<Scalars['Boolean']['input']>;
  responseAttendeeId?: InputMaybe<Scalars['String']['input']>;
};

export type BrandingText = {
  __typename?: 'BrandingText';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Contact = {
  __typename?: 'Contact';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  sisContactOrganizationId?: Maybe<Scalars['ID']['output']>;
};

export type DeleteAnswerInput = {
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  questionId?: InputMaybe<Scalars['ID']['input']>;
};

export type Document = {
  __typename?: 'Document';
  attendeeNamePermissions: Scalars['Int']['output'];
  configuration: Scalars['Int']['output'];
  customTextPermissions: Scalars['Int']['output'];
  disableAttendeeNameEditing: Scalars['Boolean']['output'];
  disableResponseEditing: Scalars['Boolean']['output'];
  formNamePermissions: Scalars['Int']['output'];
  hidden: Scalars['Boolean']['output'];
  hidePublicLinks: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isSystemTemplate: Scalars['Boolean']['output'];
  logicalOperator: Scalars['Int']['output'];
  messageBodyPermissions: Scalars['Int']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  organizationNamePermissions: Scalars['Int']['output'];
  permissionsLastEditedBy?: Maybe<Profile>;
  permissionsLastEditedOn?: Maybe<Scalars['String']['output']>;
  rosterSyncExpiryDate?: Maybe<Scalars['String']['output']>;
  rosterToMultipleGuardians: Scalars['Boolean']['output'];
  sendInvitationOnRosterSync: Scalars['Boolean']['output'];
  showContactForm: Scalars['Boolean']['output'];
  useOrganizationBranding: Scalars['Boolean']['output'];
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  active?: Maybe<Document>;
  activeId?: Maybe<Scalars['ID']['output']>;
  affirmativePermission?: Maybe<Scalars['String']['output']>;
  allowMultipleChildrenOnOneOrder: Scalars['Boolean']['output'];
  allowOnlinePaymentsOnly: Scalars['Boolean']['output'];
  attachments?: Maybe<Array<Attachment>>;
  attachmentsPermissions: Scalars['Int']['output'];
  attendeeForm?: Maybe<Scalars['String']['output']>;
  attendeeFormPermissions: Scalars['Int']['output'];
  attendeeQuestions: Array<Field>;
  attendeeQuestionsId?: Maybe<Scalars['ID']['output']>;
  confirmationMessagePermissions: Scalars['Int']['output'];
  createdBy?: Maybe<Profile>;
  customResponseStatusPermissions: Scalars['Int']['output'];
  customStatuses: Array<Field>;
  customStatusesId?: Maybe<Scalars['ID']['output']>;
  dataConverted: Scalars['Boolean']['output'];
  dateCreated: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  document: Document;
  documentId: Scalars['ID']['output'];
  documentWorkflow?: Maybe<Workflow>;
  endDate?: Maybe<Scalars['String']['output']>;
  hasApprovers?: Maybe<Scalars['Boolean']['output']>;
  hasDisabledLegacyLinks: Scalars['Boolean']['output'];
  hasReachedResponseCutOffDate?: Maybe<Scalars['Boolean']['output']>;
  headsUpDisplayPermissions: Scalars['Int']['output'];
  headsUpDisplaySelectedQuestions?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  information?: Maybe<Scalars['String']['output']>;
  isGeneralSignup: Scalars['Boolean']['output'];
  lastUpdated: Scalars['String']['output'];
  lastUpdatedBy?: Maybe<Profile>;
  latest?: Maybe<Document>;
  latestId?: Maybe<Scalars['ID']['output']>;
  linkAttachments?: Maybe<Array<LinkAttachment>>;
  manualPaymentText?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  negativePermission?: Maybe<Scalars['String']['output']>;
  oldPrivateOrganizerAnswers?: Maybe<Scalars['String']['output']>;
  oldPublicOrganizerAnswerIds?: Maybe<Scalars['String']['output']>;
  organizerName?: Maybe<Scalars['String']['output']>;
  parentMessage?: Maybe<Scalars['String']['output']>;
  permissionSlipPermissions: Scalars['Int']['output'];
  privateOrganizerQuestions?: Maybe<Scalars['String']['output']>;
  privateQuestions: Array<Field>;
  privateQuestionsId?: Maybe<Scalars['ID']['output']>;
  publicOrganizerAnswers?: Maybe<Array<Answer>>;
  publicOrganizerQuestionIds?: Maybe<Array<Scalars['ID']['output']>>;
  publicQuestions: Array<Field>;
  publicQuestionsId?: Maybe<Scalars['ID']['output']>;
  redirectMessage?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  remindersSent: Scalars['Boolean']['output'];
  requiresPermission: Scalars['Boolean']['output'];
  respondentMustSelectATicket: Scalars['Boolean']['output'];
  responseApproversPermissions: Scalars['Int']['output'];
  responseCutOffDate?: Maybe<Scalars['String']['output']>;
  responseCutOffLocalDate?: Maybe<Scalars['String']['output']>;
  responseWorkflow?: Maybe<Workflow>;
  restrictResponses: Scalars['Boolean']['output'];
  sendReminders: Scalars['Boolean']['output'];
  sequentialId: Scalars['Int']['output'];
  shortenedUrl?: Maybe<Scalars['String']['output']>;
  signeeForm?: Maybe<Scalars['String']['output']>;
  signeeFormPermissions: Scalars['Int']['output'];
  signeeQuestions: Array<Field>;
  signeeQuestionsId?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
  template?: Maybe<DocumentVersion>;
  templateId?: Maybe<Scalars['ID']['output']>;
  ticketPermissions: Scalars['Int']['output'];
  tickets?: Maybe<Array<Ticket>>;
  useLocalTranslations: Scalars['Boolean']['output'];
  useOrganizationBranding: Scalars['Boolean']['output'];
  version: Scalars['Int']['output'];
  workflowConverted: Scalars['Boolean']['output'];
};

export type DomainMutations = {
  __typename?: 'DomainMutations';
  AcceptTerms: Scalars['Boolean']['output'];
  AddResponseVersion: ResponseVersion;
  CancelTicket?: Maybe<Scalars['Boolean']['output']>;
  CreateOrResumeResponse: Array<ResponseVersion>;
  CreateResponse: ResponseVersion;
  DeleteAttendeeAnswer: Scalars['Boolean']['output'];
  DeleteSigneeAnswer: Scalars['Boolean']['output'];
  EditAttendees: Array<Attendee>;
  ReserveTicket?: Maybe<Scalars['ID']['output']>;
  RestartInProcessResponse: ResponseVersion;
  RestartResponse: ResponseVersion;
  SaveAttendeeAnswer: Answer;
  SaveSigneeAnswer: Answer;
  SignUpForNotification?: Maybe<Scalars['Boolean']['output']>;
  SubmitFeedback?: Maybe<Scalars['Boolean']['output']>;
  UpdateResponseVersion: ResponseVersion;
  UpdateTag?: Maybe<Scalars['Boolean']['output']>;
  ValidateAccess?: Maybe<Scalars['Boolean']['output']>;
};


export type DomainMutationsAcceptTermsArgs = {
  accessData?: InputMaybe<Array<AccessDataInput>>;
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  paymentToken?: InputMaybe<Scalars['String']['input']>;
  responseVersionId: Scalars['ID']['input'];
};


export type DomainMutationsAddResponseVersionArgs = {
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
};


export type DomainMutationsCancelTicketArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  purchasedTicketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  responseAttendeeId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
  ticketVersionId: Scalars['ID']['input'];
};


export type DomainMutationsCreateOrResumeResponseArgs = {
  accessData: Array<AccessDataInput>;
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  organizationHash?: InputMaybe<Scalars['String']['input']>;
  responseVersionId?: InputMaybe<Scalars['ID']['input']>;
  signee: SigneeInput;
};


export type DomainMutationsCreateResponseArgs = {
  accessData: Array<AccessDataInput>;
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  organizationHash?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  responseVersionId?: InputMaybe<Scalars['ID']['input']>;
  signee: SigneeInput;
};


export type DomainMutationsDeleteAttendeeAnswerArgs = {
  accessData: Array<AccessDataInput>;
  answerInput: DeleteAnswerInput;
  attendeeId: Scalars['ID']['input'];
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
};


export type DomainMutationsDeleteSigneeAnswerArgs = {
  accessData: Array<AccessDataInput>;
  answerInput: DeleteAnswerInput;
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
};


export type DomainMutationsEditAttendeesArgs = {
  accessData: Array<AccessDataInput>;
  attendees: Array<AttendeeInput>;
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
};


export type DomainMutationsReserveTicketArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
  reserveTicketInput?: InputMaybe<ReserveTicketInput>;
  responseAttendeeId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
  ticketVersionId: Scalars['ID']['input'];
};


export type DomainMutationsRestartInProcessResponseArgs = {
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
};


export type DomainMutationsRestartResponseArgs = {
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
};


export type DomainMutationsSaveAttendeeAnswerArgs = {
  accessData: Array<AccessDataInput>;
  answer: AnswerInput;
  attendeeId: Scalars['ID']['input'];
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
};


export type DomainMutationsSaveSigneeAnswerArgs = {
  accessData: Array<AccessDataInput>;
  answer: AnswerInput;
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
};


export type DomainMutationsSignUpForNotificationArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  documentVersionId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
};


export type DomainMutationsSubmitFeedbackArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  documentVersionId: Scalars['ID']['input'];
  feedback?: InputMaybe<Scalars['String']['input']>;
  responseVersionId: Scalars['ID']['input'];
  signeeEmailAddress?: InputMaybe<Scalars['String']['input']>;
  signeeFirstName?: InputMaybe<Scalars['String']['input']>;
  signeeLastName?: InputMaybe<Scalars['String']['input']>;
};


export type DomainMutationsUpdateResponseVersionArgs = {
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
};


export type DomainMutationsUpdateTagArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
  tagId?: InputMaybe<Scalars['ID']['input']>;
};


export type DomainMutationsValidateAccessArgs = {
  accessData?: InputMaybe<Array<InputMaybe<AccessDataInput>>>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
};

export type DomainQueries = {
  __typename?: 'DomainQueries';
  EligibleTags: Array<Tag>;
  Form: DocumentVersion;
  FormByHash: LegacyHashResolution;
  Organization: Organization;
  OrganizationByHash: Organization;
  Response: ResponseVersion;
  ResponseByHash: LegacyHashResolution;
  ResponseVersions: Array<ResponseVersion>;
  StaffResponseVersions: Array<ResponseVersion>;
  TaxesAndFees: TaxesAndFees;
  TicketInventory: Array<TicketInventory>;
};


export type DomainQueriesEligibleTagsArgs = {
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type DomainQueriesFormArgs = {
  countryCode: Scalars['String']['input'];
  hashedOrgId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type DomainQueriesFormByHashArgs = {
  countryCode: Scalars['String']['input'];
  hashedId: Scalars['String']['input'];
};


export type DomainQueriesOrganizationArgs = {
  countryCode: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type DomainQueriesOrganizationByHashArgs = {
  countryCode: Scalars['String']['input'];
  hash: Scalars['String']['input'];
};


export type DomainQueriesResponseArgs = {
  countryCode: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type DomainQueriesResponseByHashArgs = {
  hashedId: Scalars['String']['input'];
};


export type DomainQueriesResponseVersionsArgs = {
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};


export type DomainQueriesStaffResponseVersionsArgs = {
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
};


export type DomainQueriesTaxesAndFeesArgs = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  passFeesToBuyer: Scalars['Boolean']['input'];
};


export type DomainQueriesTicketInventoryArgs = {
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  ticketIds: Array<Scalars['ID']['input']>;
};

export enum FeeMethod {
  BankTransfer = 'BankTransfer',
  DomesticCreditCard = 'DomesticCreditCard',
  DomesticDebitCard = 'DomesticDebitCard',
  DomesticPrepaidCard = 'DomesticPrepaidCard',
  InternationalCreditCard = 'InternationalCreditCard',
  InternationalDebitCard = 'InternationalDebitCard',
  InternationalPrepaidCard = 'InternationalPrepaidCard',
  Unknown = 'Unknown'
}

export type Field = {
  __typename?: 'Field';
  collapsable: Scalars['Boolean']['output'];
  equationSections?: Maybe<Array<Question>>;
  fields?: Maybe<Array<Field>>;
  id: Scalars['ID']['output'];
  question?: Maybe<Question>;
  readonly: Scalars['Boolean']['output'];
  type: FieldType;
};

export enum FieldType {
  Address = 'ADDRESS',
  Conditional = 'CONDITIONAL',
  Date = 'DATE',
  Descriptivetext = 'DESCRIPTIVETEXT',
  Divider = 'DIVIDER',
  Dropdown = 'DROPDOWN',
  Equations = 'EQUATIONS',
  FieldContainer = 'FIELD_CONTAINER',
  Header = 'HEADER',
  IntegratedData = 'INTEGRATED_DATA',
  Multiline = 'MULTILINE',
  Multiselect = 'MULTISELECT',
  MultiFieldConditional = 'MULTI_FIELD_CONDITIONAL',
  Phonenumber = 'PHONENUMBER',
  PostalZip = 'POSTAL_ZIP',
  Rating = 'RATING',
  RepeatableQuestion = 'REPEATABLE_QUESTION',
  Section = 'SECTION',
  Select = 'SELECT',
  Selectmultiple = 'SELECTMULTIPLE',
  SelectConditional = 'SELECT_CONDITIONAL',
  Singleline = 'SINGLELINE',
  Time = 'TIME',
  Upload = 'UPLOAD',
  Yesno = 'YESNO'
}

export type IntegratedDataValue = {
  __typename?: 'IntegratedDataValue';
  integratedDataFieldId: Scalars['String']['output'];
  profileId: Scalars['ID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type Inventory = {
  __typename?: 'Inventory';
  draftInitial?: Maybe<Scalars['Int']['output']>;
  draftRemaining?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isLimited: Scalars['Boolean']['output'];
  remaining?: Maybe<Scalars['Int']['output']>;
};

export type LegacyHashResolution = {
  __typename?: 'LegacyHashResolution';
  isRetired: Scalars['Boolean']['output'];
};

export type LinkAttachment = {
  __typename?: 'LinkAttachment';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUri?: Maybe<Scalars['String']['output']>;
  originalUri?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uri?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  amountOutstanding?: Maybe<Scalars['Float']['output']>;
  baseFee?: Maybe<Scalars['Float']['output']>;
  baseFeeString?: Maybe<Scalars['String']['output']>;
  canRefund?: Maybe<Scalars['Boolean']['output']>;
  date: Scalars['String']['output'];
  grandTotal?: Maybe<Scalars['Float']['output']>;
  grandTotalOriginal?: Maybe<Scalars['Float']['output']>;
  hasBeenPaid?: Maybe<Scalars['Boolean']['output']>;
  isCheckedOut?: Maybe<Scalars['Boolean']['output']>;
  isRefunded?: Maybe<Scalars['Boolean']['output']>;
  orderId: Scalars['ID']['output'];
  orderNumber: Scalars['String']['output'];
  paymentTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  purchasedTickets: Array<PurchasedTicket>;
  purchaserFirstName?: Maybe<Scalars['String']['output']>;
  purchaserLastName?: Maybe<Scalars['String']['output']>;
  refundedAmount?: Maybe<Scalars['Float']['output']>;
  subTotal?: Maybe<Scalars['Float']['output']>;
  totalFees?: Maybe<Scalars['Float']['output']>;
  totalFeesString?: Maybe<Scalars['String']['output']>;
  wasManuallyPaid?: Maybe<Scalars['Boolean']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  accessFields?: Maybe<Array<Maybe<AccessField>>>;
  address?: Maybe<Array<Maybe<Address>>>;
  apiKey?: Maybe<Scalars['String']['output']>;
  brandingTextValues?: Maybe<Array<Maybe<BrandingText>>>;
  contact?: Maybe<Contact>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Profile>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  dateCreated?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  divisionName?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<Document>>>;
  domain?: Maybe<Scalars['String']['output']>;
  editionId: Scalars['Int']['output'];
  emailSettingsId?: Maybe<Scalars['String']['output']>;
  formsRequireApproval: Scalars['Boolean']['output'];
  hasAccessFields?: Maybe<Scalars['Boolean']['output']>;
  hasLogo: Scalars['Boolean']['output'];
  hasSafePay?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  logoMetadataId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameForCommunications?: Maybe<Scalars['String']['output']>;
  numberOfStudents?: Maybe<Scalars['Int']['output']>;
  organizationTypeCode: OrganizationType;
  parent?: Maybe<Organization>;
  parentId?: Maybe<Scalars['ID']['output']>;
  paymentSettingsId?: Maybe<Scalars['ID']['output']>;
  roleLabels?: Maybe<RoleLabels>;
  sequentialId: Scalars['Int']['output'];
  stripeBillingId?: Maybe<Scalars['String']['output']>;
  trialEnding: Scalars['Boolean']['output'];
  webPageUrl?: Maybe<Scalars['String']['output']>;
};

export enum OrganizationType {
  District = 'District'
}

export enum PaidStatus {
  Cancelled = 'Cancelled',
  FullyRefunded = 'FullyRefunded',
  NotApplicable = 'NotApplicable',
  Paid = 'Paid',
  PartiallyRefunded = 'PartiallyRefunded',
  PaymentRequired = 'PaymentRequired'
}

export type Profile = {
  __typename?: 'Profile';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PurchasedTicket = {
  __typename?: 'PurchasedTicket';
  answers: Array<Answer>;
  attendeeId?: Maybe<Scalars['ID']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderNumber: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  purchasedTicketIds: Array<Scalars['ID']['output']>;
  quantity: Scalars['Int']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  ticketId: Scalars['ID']['output'];
  ticketVersionId: Scalars['ID']['output'];
  totalPrice: Scalars['Float']['output'];
  type: TicketTypeInfo;
};

export type Question = {
  __typename?: 'Question';
  characterLimit?: Maybe<Scalars['Int']['output']>;
  dataValue?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  integratedDataValue?: Maybe<IntegratedDataValue>;
  isRequired: Scalars['Boolean']['output'];
  labelText?: Maybe<Scalars['String']['output']>;
  maxEntries?: Maybe<Scalars['Int']['output']>;
  minEntries?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pinnedValueOptions?: Maybe<Array<Scalars['String']['output']>>;
  placeHolderText?: Maybe<Scalars['String']['output']>;
  plainLabel?: Maybe<Scalars['String']['output']>;
  reportingLabel?: Maybe<Scalars['String']['output']>;
  sortValueOptions: Scalars['Boolean']['output'];
  supportsApprovers?: Maybe<Scalars['Boolean']['output']>;
  valueOptions?: Maybe<Array<Scalars['String']['output']>>;
  valueType?: Maybe<Scalars['String']['output']>;
};

export type ReserveTicketInput = {
  answers: Array<AnswerInput>;
  openValueAmount?: InputMaybe<Scalars['Float']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
};

export enum ResponseSource {
  AzureAd = 'AzureAD',
  Clever = 'Clever',
  Google = 'Google',
  Internal = 'Internal',
  Manual = 'Manual',
  MyPowerHub = 'MyPowerHub',
  Organic = 'Organic',
  Paper = 'Paper',
  PermissionClick = 'PermissionClick',
  Process = 'Process',
  QuickAdd = 'QuickAdd',
  SisImport = 'SisImport'
}

export enum ResponseStatus {
  Cancelled = 'Cancelled',
  NotSent = 'NotSent',
  Opened = 'Opened',
  Pending = 'Pending',
  PendingApproval = 'PendingApproval',
  Rejected = 'Rejected',
  Responded = 'Responded',
  Started = 'Started',
  Unknown = 'Unknown',
  Unopened = 'Unopened'
}

export type ResponseVersion = {
  __typename?: 'ResponseVersion';
  attendees: Array<Attendee>;
  completedByOrganizationName?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['String']['output'];
  documentHashId: Scalars['String']['output'];
  documentVersionId: Scalars['ID']['output'];
  hash: Scalars['String']['output'];
  isCheckedOut: Scalars['Boolean']['output'];
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  isManual: Scalars['Boolean']['output'];
  isPaymentRequired: Scalars['Boolean']['output'];
  isRostered: Scalars['Boolean']['output'];
  isSigned: Scalars['Boolean']['output'];
  orderId?: Maybe<Scalars['ID']['output']>;
  orderStatus: PaidStatus;
  orders: Array<Order>;
  originalValueUri?: Maybe<Scalars['String']['output']>;
  previousOrders?: Maybe<Array<Order>>;
  responseOrganizationId: Scalars['ID']['output'];
  responseVersionId: Scalars['ID']['output'];
  signedDate?: Maybe<Scalars['String']['output']>;
  signeeAnswers: Array<Answer>;
  signeeAttachmentFileType?: Maybe<Scalars['String']['output']>;
  signeeAttachmentId?: Maybe<Scalars['ID']['output']>;
  signeeEmail?: Maybe<Scalars['String']['output']>;
  signeeFirstName?: Maybe<Scalars['String']['output']>;
  signeeLastName?: Maybe<Scalars['String']['output']>;
  signeeNotes?: Maybe<Scalars['String']['output']>;
  source: ResponseSource;
  sourceId?: Maybe<Scalars['String']['output']>;
  status: ResponseStatus;
  subTotal: Scalars['Float']['output'];
  tagId?: Maybe<Scalars['ID']['output']>;
  total: Scalars['Float']['output'];
};

export type RoleLabels = {
  __typename?: 'RoleLabels';
  administrator: Scalars['String']['output'];
  attendee: Scalars['String']['output'];
  guardian: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizer: Scalars['String']['output'];
};

export type SigneeInput = {
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  attendeeId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  responseSource: ResponseSource;
  tagId?: InputMaybe<Scalars['ID']['input']>;
};

export type Tag = {
  __typename?: 'Tag';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Tax = {
  __typename?: 'Tax';
  gst: Scalars['Decimal']['output'];
  gstLabel?: Maybe<Scalars['String']['output']>;
  pst: Scalars['Decimal']['output'];
  pstLabel?: Maybe<Scalars['String']['output']>;
  total: Scalars['Decimal']['output'];
};

export type TaxAndFeeEstimate = {
  __typename?: 'TaxAndFeeEstimate';
  amountToCharge: Scalars['Decimal']['output'];
  method: FeeMethod;
  serviceFee: Scalars['Decimal']['output'];
  tax: Tax;
};

export type TaxesAndFees = {
  __typename?: 'TaxesAndFees';
  amount: Scalars['Decimal']['output'];
  estimates: Array<TaxAndFeeEstimate>;
  typicalMethodEstimate: TaxAndFeeEstimate;
};

export type Ticket = {
  __typename?: 'Ticket';
  description?: Maybe<Scalars['String']['output']>;
  documentVersionId: Scalars['ID']['output'];
  endSellingDate?: Maybe<Scalars['String']['output']>;
  formQuestions?: Maybe<Array<Field>>;
  formQuestionsId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  imageId?: Maybe<Scalars['ID']['output']>;
  inventory: Inventory;
  maximumQuantity?: Maybe<Scalars['Int']['output']>;
  minimumQuantity?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  passAlongFees: Scalars['Boolean']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  startSellingDate?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  ticketId: Scalars['ID']['output'];
  typeCode: Scalars['Int']['output'];
};

export type TicketInventory = {
  __typename?: 'TicketInventory';
  initial?: Maybe<Scalars['Int']['output']>;
  isLimited: Scalars['Boolean']['output'];
  purchased: Scalars['Int']['output'];
  remaining?: Maybe<Scalars['Int']['output']>;
  ticketId: Scalars['ID']['output'];
};

export type TicketTypeInfo = {
  __typename?: 'TicketTypeInfo';
  code?: Maybe<Scalars['String']['output']>;
  defaultPrice: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
};

export type Workflow = {
  __typename?: 'Workflow';
  id: Scalars['ID']['output'];
};

export type SaveSigneeAnswerMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  answer: AnswerInput;
  responseVersionId: Scalars['ID']['input'];
  accessData: Array<AccessDataInput> | AccessDataInput;
}>;


export type SaveSigneeAnswerMutation = { __typename?: 'DomainMutations', SaveSigneeAnswer: { __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string } };

export type DeleteSigneeAnswerMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
  answerInput: DeleteAnswerInput;
  accessData: Array<AccessDataInput> | AccessDataInput;
}>;


export type DeleteSigneeAnswerMutation = { __typename?: 'DomainMutations', DeleteSigneeAnswer: boolean };

export type SaveAttendeeAnswerMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  answer: AnswerInput;
  responseVersionId: Scalars['ID']['input'];
  attendeeId: Scalars['ID']['input'];
  accessData: Array<AccessDataInput> | AccessDataInput;
}>;


export type SaveAttendeeAnswerMutation = { __typename?: 'DomainMutations', SaveAttendeeAnswer: { __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string } };

export type DeleteAttendeeAnswerMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
  answerInput: DeleteAnswerInput;
  attendeeId: Scalars['ID']['input'];
  accessData: Array<AccessDataInput> | AccessDataInput;
}>;


export type DeleteAttendeeAnswerMutation = { __typename?: 'DomainMutations', DeleteAttendeeAnswer: boolean };

export type EditAttendeesMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
  attendees: Array<AttendeeInput> | AttendeeInput;
  accessData: Array<AccessDataInput> | AccessDataInput;
}>;


export type EditAttendeesMutation = { __typename?: 'DomainMutations', EditAttendees: Array<{ __typename?: 'Attendee', responseAttendeeId: string, attendeeId: string, firstName?: string | null, lastName?: string | null, permitted?: boolean | null, manualPermissionDate?: string | null, attachmentId?: string | null, attachmentFileType?: string | null, notes?: string | null }> };

export type CreateOrResumeResponseMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  signee: SigneeInput;
  organizationHash?: InputMaybe<Scalars['String']['input']>;
  responseVersionId?: InputMaybe<Scalars['ID']['input']>;
  accessData: Array<AccessDataInput> | AccessDataInput;
}>;


export type CreateOrResumeResponseMutation = { __typename?: 'DomainMutations', CreateOrResumeResponse: Array<{ __typename: 'ResponseVersion', responseVersionId: string, documentVersionId: string, documentHashId: string, hash: string, completedByOrganizationName?: string | null, responseOrganizationId: string, isRostered: boolean, orderStatus: PaidStatus, isPaymentRequired: boolean, status: ResponseStatus, total: number, subTotal: number, signeeEmail?: string | null, signeeFirstName?: string | null, signeeLastName?: string | null, isSigned: boolean, isCheckedOut: boolean, createdDate: string, source: ResponseSource, sourceId?: string | null, isInternal?: boolean | null, isManual: boolean, signedDate?: string | null, signeeNotes?: string | null, signeeAttachmentId?: string | null, signeeAttachmentFileType?: string | null, originalValueUri?: string | null, tagId?: string | null, attendees: Array<{ __typename?: 'Attendee', responseAttendeeId: string, attendeeId: string, firstName?: string | null, lastName?: string | null, permitted?: boolean | null, manualPermissionDate?: string | null, attachmentId?: string | null, attachmentFileType?: string | null, notes?: string | null, tickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }>, attendeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, integratedDataOnFile?: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> | null }>, signeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, orders: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }>, previousOrders?: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }> | null }> };

export type CreateResponseMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  signee: SigneeInput;
  organizationHash?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  responseVersionId?: InputMaybe<Scalars['ID']['input']>;
  accessData: Array<AccessDataInput> | AccessDataInput;
}>;


export type CreateResponseMutation = { __typename?: 'DomainMutations', CreateResponse: { __typename: 'ResponseVersion', responseVersionId: string, documentVersionId: string, documentHashId: string, hash: string, completedByOrganizationName?: string | null, responseOrganizationId: string, isRostered: boolean, orderStatus: PaidStatus, isPaymentRequired: boolean, status: ResponseStatus, total: number, subTotal: number, signeeEmail?: string | null, signeeFirstName?: string | null, signeeLastName?: string | null, isSigned: boolean, isCheckedOut: boolean, createdDate: string, source: ResponseSource, sourceId?: string | null, isInternal?: boolean | null, isManual: boolean, signedDate?: string | null, signeeNotes?: string | null, signeeAttachmentId?: string | null, signeeAttachmentFileType?: string | null, originalValueUri?: string | null, tagId?: string | null, attendees: Array<{ __typename?: 'Attendee', responseAttendeeId: string, attendeeId: string, firstName?: string | null, lastName?: string | null, permitted?: boolean | null, manualPermissionDate?: string | null, attachmentId?: string | null, attachmentFileType?: string | null, notes?: string | null, tickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }>, attendeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, integratedDataOnFile?: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> | null }>, signeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, orders: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }>, previousOrders?: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }> | null } };

export type RestartResponseMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
}>;


export type RestartResponseMutation = { __typename?: 'DomainMutations', RestartResponse: { __typename: 'ResponseVersion', responseVersionId: string, documentVersionId: string, documentHashId: string, hash: string, completedByOrganizationName?: string | null, responseOrganizationId: string, isRostered: boolean, orderStatus: PaidStatus, isPaymentRequired: boolean, status: ResponseStatus, total: number, subTotal: number, signeeEmail?: string | null, signeeFirstName?: string | null, signeeLastName?: string | null, isSigned: boolean, isCheckedOut: boolean, createdDate: string, source: ResponseSource, sourceId?: string | null, isInternal?: boolean | null, isManual: boolean, signedDate?: string | null, signeeNotes?: string | null, signeeAttachmentId?: string | null, signeeAttachmentFileType?: string | null, originalValueUri?: string | null, tagId?: string | null, attendees: Array<{ __typename?: 'Attendee', responseAttendeeId: string, attendeeId: string, firstName?: string | null, lastName?: string | null, permitted?: boolean | null, manualPermissionDate?: string | null, attachmentId?: string | null, attachmentFileType?: string | null, notes?: string | null, tickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }>, attendeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, integratedDataOnFile?: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> | null }>, signeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, orders: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }>, previousOrders?: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }> | null } };

export type RestartInProcessResponseMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
}>;


export type RestartInProcessResponseMutation = { __typename?: 'DomainMutations', RestartInProcessResponse: { __typename: 'ResponseVersion', responseVersionId: string, documentVersionId: string, documentHashId: string, hash: string, completedByOrganizationName?: string | null, responseOrganizationId: string, isRostered: boolean, orderStatus: PaidStatus, isPaymentRequired: boolean, status: ResponseStatus, total: number, subTotal: number, signeeEmail?: string | null, signeeFirstName?: string | null, signeeLastName?: string | null, isSigned: boolean, isCheckedOut: boolean, createdDate: string, source: ResponseSource, sourceId?: string | null, isInternal?: boolean | null, isManual: boolean, signedDate?: string | null, signeeNotes?: string | null, signeeAttachmentId?: string | null, signeeAttachmentFileType?: string | null, originalValueUri?: string | null, tagId?: string | null, attendees: Array<{ __typename?: 'Attendee', responseAttendeeId: string, attendeeId: string, firstName?: string | null, lastName?: string | null, permitted?: boolean | null, manualPermissionDate?: string | null, attachmentId?: string | null, attachmentFileType?: string | null, notes?: string | null, tickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }>, attendeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, integratedDataOnFile?: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> | null }>, signeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, orders: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }>, previousOrders?: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }> | null } };

export type AddResponseVersionMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
}>;


export type AddResponseVersionMutation = { __typename?: 'DomainMutations', AddResponseVersion: { __typename: 'ResponseVersion', responseVersionId: string, documentVersionId: string, documentHashId: string, hash: string, completedByOrganizationName?: string | null, responseOrganizationId: string, isRostered: boolean, orderStatus: PaidStatus, isPaymentRequired: boolean, status: ResponseStatus, total: number, subTotal: number, signeeEmail?: string | null, signeeFirstName?: string | null, signeeLastName?: string | null, isSigned: boolean, isCheckedOut: boolean, createdDate: string, source: ResponseSource, sourceId?: string | null, isInternal?: boolean | null, isManual: boolean, signedDate?: string | null, signeeNotes?: string | null, signeeAttachmentId?: string | null, signeeAttachmentFileType?: string | null, originalValueUri?: string | null, tagId?: string | null, attendees: Array<{ __typename?: 'Attendee', responseAttendeeId: string, attendeeId: string, firstName?: string | null, lastName?: string | null, permitted?: boolean | null, manualPermissionDate?: string | null, attachmentId?: string | null, attachmentFileType?: string | null, notes?: string | null, tickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }>, attendeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, integratedDataOnFile?: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> | null }>, signeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, orders: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }>, previousOrders?: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }> | null } };

export type UpdateResponseVersionMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
}>;


export type UpdateResponseVersionMutation = { __typename?: 'DomainMutations', UpdateResponseVersion: { __typename: 'ResponseVersion', responseVersionId: string, documentVersionId: string, documentHashId: string, hash: string, completedByOrganizationName?: string | null, responseOrganizationId: string, isRostered: boolean, orderStatus: PaidStatus, isPaymentRequired: boolean, status: ResponseStatus, total: number, subTotal: number, signeeEmail?: string | null, signeeFirstName?: string | null, signeeLastName?: string | null, isSigned: boolean, isCheckedOut: boolean, createdDate: string, source: ResponseSource, sourceId?: string | null, isInternal?: boolean | null, isManual: boolean, signedDate?: string | null, signeeNotes?: string | null, signeeAttachmentId?: string | null, signeeAttachmentFileType?: string | null, originalValueUri?: string | null, tagId?: string | null, attendees: Array<{ __typename?: 'Attendee', responseAttendeeId: string, attendeeId: string, firstName?: string | null, lastName?: string | null, permitted?: boolean | null, manualPermissionDate?: string | null, attachmentId?: string | null, attachmentFileType?: string | null, notes?: string | null, tickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }>, attendeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, integratedDataOnFile?: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> | null }>, signeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, orders: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }>, previousOrders?: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }> | null } };

export type ValidateAccessMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  accessData: Array<AccessDataInput> | AccessDataInput;
  responseVersionId: Scalars['ID']['input'];
}>;


export type ValidateAccessMutation = { __typename?: 'DomainMutations', ValidateAccess?: boolean | null };

export type UpdateTagMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  countryCode: Scalars['String']['input'];
  tagId?: InputMaybe<Scalars['ID']['input']>;
  responseVersionId: Scalars['ID']['input'];
}>;


export type UpdateTagMutation = { __typename?: 'DomainMutations', UpdateTag?: boolean | null };

export type AcceptTermsMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
  accessData?: InputMaybe<Array<AccessDataInput> | AccessDataInput>;
  paymentToken?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type AcceptTermsMutation = { __typename?: 'DomainMutations', AcceptTerms: boolean };

export type SignUpForNotificationMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  documentVersionId: Scalars['ID']['input'];
}>;


export type SignUpForNotificationMutation = { __typename?: 'DomainMutations', SignUpForNotification?: boolean | null };

export type SubmitFeedbackMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentVersionId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
  feedback: Scalars['String']['input'];
  signeeEmailAddress: Scalars['String']['input'];
  signeeFirstName: Scalars['String']['input'];
  signeeLastName: Scalars['String']['input'];
}>;


export type SubmitFeedbackMutation = { __typename?: 'DomainMutations', SubmitFeedback?: boolean | null };

export type ReserveTicketMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
  responseAttendeeId: Scalars['ID']['input'];
  ticketVersionId: Scalars['ID']['input'];
  reserveTicketInput: ReserveTicketInput;
}>;


export type ReserveTicketMutation = { __typename?: 'DomainMutations', ReserveTicket?: string | null };

export type CancelTicketMutationVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  responseVersionId: Scalars['ID']['input'];
  responseAttendeeId: Scalars['ID']['input'];
  ticketVersionId: Scalars['ID']['input'];
  purchasedTicketIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
}>;


export type CancelTicketMutation = { __typename?: 'DomainMutations', CancelTicket?: boolean | null };

export type FormInfoQueryVariables = Exact<{
  token: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  hashedOrgId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FormInfoQuery = { __typename?: 'DomainQueries', Form: { __typename?: 'DocumentVersion', id: string, name?: string | null, status: number, redirectUrl?: string | null, documentId: string, redirectMessage?: string | null, allowMultipleChildrenOnOneOrder: boolean, allowOnlinePaymentsOnly: boolean, respondentMustSelectATicket: boolean, manualPaymentText?: string | null, parentMessage?: string | null, information?: string | null, organizerName?: string | null, requiresPermission: boolean, isGeneralSignup: boolean, restrictResponses: boolean, hasApprovers?: boolean | null, hasReachedResponseCutOffDate?: boolean | null, responseCutOffLocalDate?: string | null, startDate?: string | null, endDate?: string | null, affirmativePermission?: string | null, negativePermission?: string | null, useOrganizationBranding: boolean, useLocalTranslations: boolean, document: { __typename?: 'Document', id: string, disableResponseEditing: boolean, disableAttendeeNameEditing: boolean, showContactForm: boolean, organization: { __typename?: 'Organization', id: string, isEnabled: boolean, name?: string | null, logo?: string | null, hasSafePay?: boolean | null, countryCode?: string | null, currencyCode?: string | null, disclaimer?: string | null, parent?: { __typename?: 'Organization', id: string, isEnabled: boolean, name?: string | null, logo?: string | null, hasSafePay?: boolean | null, countryCode?: string | null, currencyCode?: string | null, disclaimer?: string | null, roleLabels?: { __typename?: 'RoleLabels', organization: string, administrator: string, organizer: string, guardian: string, attendee: string } | null, accessFields?: Array<{ __typename?: 'AccessField', key: string, field: { __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null } } | null> | null } | null, roleLabels?: { __typename?: 'RoleLabels', organization: string, administrator: string, organizer: string, guardian: string, attendee: string } | null, accessFields?: Array<{ __typename?: 'AccessField', key: string, field: { __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null } } | null> | null } }, attachments?: Array<{ __typename?: 'Attachment', id: string, friendlyName?: string | null, name: string, isPdf: boolean, contentUri: string, thumbnailUri: string, printUri: string, downloadUri: string, fileType: string, readableFileSize?: string | null, mimeType: string, isImage: boolean, sizeInBytes?: number | null, isPrimary: boolean }> | null, linkAttachments?: Array<{ __typename?: 'LinkAttachment', id: string, title?: string | null, description?: string | null, uri?: string | null, imageUri?: string | null, originalUri?: string | null }> | null, publicQuestions: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null }> | null }> | null }> | null }>, publicOrganizerAnswers?: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> | null, signeeQuestions: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null }> | null }> | null }> | null }>, attendeeQuestions: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null }> | null }> | null }> | null }>, tickets?: Array<{ __typename?: 'Ticket', id: string, name?: string | null, description?: string | null, startSellingDate?: string | null, endSellingDate?: string | null, imageId?: string | null, typeCode: number, minimumQuantity?: number | null, maximumQuantity?: number | null, price?: number | null, passAlongFees: boolean, ticketId: string, documentVersionId: string, formQuestionsId?: string | null, thumbnailUrl?: string | null, inventory: { __typename?: 'Inventory', id: string, isLimited: boolean, remaining?: number | null, draftInitial?: number | null, draftRemaining?: number | null }, formQuestions?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null }> | null }> | null }> | null }> | null }> | null, template?: { __typename?: 'DocumentVersion', attachmentsPermissions: number, ticketPermissions: number, signeeFormPermissions: number, attendeeFormPermissions: number, document: { __typename?: 'Document', id: string, disableResponseEditing: boolean, disableAttendeeNameEditing: boolean, showContactForm: boolean, organization: { __typename?: 'Organization', id: string, isEnabled: boolean, name?: string | null, logo?: string | null, hasSafePay?: boolean | null, countryCode?: string | null, currencyCode?: string | null, disclaimer?: string | null, parent?: { __typename?: 'Organization', id: string, isEnabled: boolean, name?: string | null, logo?: string | null, hasSafePay?: boolean | null, countryCode?: string | null, currencyCode?: string | null, disclaimer?: string | null, roleLabels?: { __typename?: 'RoleLabels', organization: string, administrator: string, organizer: string, guardian: string, attendee: string } | null, accessFields?: Array<{ __typename?: 'AccessField', key: string, field: { __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null } } | null> | null } | null, roleLabels?: { __typename?: 'RoleLabels', organization: string, administrator: string, organizer: string, guardian: string, attendee: string } | null, accessFields?: Array<{ __typename?: 'AccessField', key: string, field: { __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null } } | null> | null } }, attachments?: Array<{ __typename?: 'Attachment', id: string, friendlyName?: string | null, name: string, isPdf: boolean, contentUri: string, thumbnailUri: string, printUri: string, downloadUri: string, fileType: string, readableFileSize?: string | null, mimeType: string, isImage: boolean, sizeInBytes?: number | null, isPrimary: boolean }> | null, linkAttachments?: Array<{ __typename?: 'LinkAttachment', id: string, title?: string | null, description?: string | null, uri?: string | null, imageUri?: string | null, originalUri?: string | null }> | null, publicQuestions: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null }> | null }> | null }> | null }>, signeeQuestions: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null }> | null }> | null }> | null }>, attendeeQuestions: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null }> | null }> | null }> | null }>, tickets?: Array<{ __typename?: 'Ticket', id: string, name?: string | null, description?: string | null, startSellingDate?: string | null, endSellingDate?: string | null, imageId?: string | null, typeCode: number, minimumQuantity?: number | null, maximumQuantity?: number | null, price?: number | null, passAlongFees: boolean, ticketId: string, documentVersionId: string, formQuestionsId?: string | null, thumbnailUrl?: string | null, inventory: { __typename?: 'Inventory', id: string, isLimited: boolean, remaining?: number | null, draftInitial?: number | null, draftRemaining?: number | null }, formQuestions?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null }> | null }> | null }> | null }> | null }> | null } | null } };

export type FormByHashQueryVariables = Exact<{
  hashedId: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
}>;


export type FormByHashQuery = { __typename?: 'DomainQueries', FormByHash: { __typename?: 'LegacyHashResolution', isRetired: boolean } };

export type ResponseByHashQueryVariables = Exact<{
  hashedId: Scalars['String']['input'];
}>;


export type ResponseByHashQuery = { __typename?: 'DomainQueries', ResponseByHash: { __typename?: 'LegacyHashResolution', isRetired: boolean } };

export type FormAttachmentFragmentFragment = { __typename?: 'Attachment', id: string, friendlyName?: string | null, name: string, isPdf: boolean, contentUri: string, thumbnailUri: string, printUri: string, downloadUri: string, fileType: string, readableFileSize?: string | null, mimeType: string, isImage: boolean, sizeInBytes?: number | null, isPrimary: boolean };

export type LinkAttachmentFragmentFragment = { __typename?: 'LinkAttachment', id: string, title?: string | null, description?: string | null, uri?: string | null, imageUri?: string | null, originalUri?: string | null };

export type FieldFragmentFragment = { __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean };

export type QuestionFragmentFragment = { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null };

export type AnswerFragmentFragment = { __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string };

export type TicketFragmentFragment = { __typename?: 'Ticket', id: string, name?: string | null, description?: string | null, startSellingDate?: string | null, endSellingDate?: string | null, imageId?: string | null, typeCode: number, minimumQuantity?: number | null, maximumQuantity?: number | null, price?: number | null, passAlongFees: boolean, ticketId: string, documentVersionId: string, formQuestionsId?: string | null, thumbnailUrl?: string | null, inventory: { __typename?: 'Inventory', id: string, isLimited: boolean, remaining?: number | null, draftInitial?: number | null, draftRemaining?: number | null }, formQuestions?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null, fields?: Array<{ __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, equationSections?: Array<{ __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null }> | null, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null }> | null }> | null }> | null }> | null };

export type TicketTypeFragmentFragment = { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number };

export type PurchasedTicketFragmentFragment = { __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> };

export type AttendeeFragmentFragment = { __typename?: 'Attendee', responseAttendeeId: string, attendeeId: string, firstName?: string | null, lastName?: string | null, permitted?: boolean | null, manualPermissionDate?: string | null, attachmentId?: string | null, attachmentFileType?: string | null, notes?: string | null, tickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }>, attendeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, integratedDataOnFile?: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> | null };

export type OrderFragmentFragment = { __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> };

export type ResponseVersionFragmentFragment = { __typename?: 'ResponseVersion', responseVersionId: string, documentVersionId: string, documentHashId: string, hash: string, completedByOrganizationName?: string | null, responseOrganizationId: string, isRostered: boolean, orderStatus: PaidStatus, isPaymentRequired: boolean, status: ResponseStatus, total: number, subTotal: number, signeeEmail?: string | null, signeeFirstName?: string | null, signeeLastName?: string | null, isSigned: boolean, isCheckedOut: boolean, createdDate: string, source: ResponseSource, sourceId?: string | null, isInternal?: boolean | null, isManual: boolean, signedDate?: string | null, signeeNotes?: string | null, signeeAttachmentId?: string | null, signeeAttachmentFileType?: string | null, originalValueUri?: string | null, tagId?: string | null, attendees: Array<{ __typename?: 'Attendee', responseAttendeeId: string, attendeeId: string, firstName?: string | null, lastName?: string | null, permitted?: boolean | null, manualPermissionDate?: string | null, attachmentId?: string | null, attachmentFileType?: string | null, notes?: string | null, tickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }>, attendeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, integratedDataOnFile?: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> | null }>, signeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, orders: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }>, previousOrders?: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }> | null };

export type IntegratedDataValueFragmentFragment = { __typename?: 'IntegratedDataValue', value?: string | null, integratedDataFieldId: string, profileId: string };

export type OrganizationFragmentFragment = { __typename?: 'Organization', id: string, isEnabled: boolean, name?: string | null, logo?: string | null, hasSafePay?: boolean | null, countryCode?: string | null, currencyCode?: string | null, disclaimer?: string | null, roleLabels?: { __typename?: 'RoleLabels', organization: string, administrator: string, organizer: string, guardian: string, attendee: string } | null, accessFields?: Array<{ __typename?: 'AccessField', key: string, field: { __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null } } | null> | null };

export type DocumentFragmentFragment = { __typename?: 'Document', id: string, disableResponseEditing: boolean, disableAttendeeNameEditing: boolean, showContactForm: boolean, organization: { __typename?: 'Organization', id: string, isEnabled: boolean, name?: string | null, logo?: string | null, hasSafePay?: boolean | null, countryCode?: string | null, currencyCode?: string | null, disclaimer?: string | null, parent?: { __typename?: 'Organization', id: string, isEnabled: boolean, name?: string | null, logo?: string | null, hasSafePay?: boolean | null, countryCode?: string | null, currencyCode?: string | null, disclaimer?: string | null, roleLabels?: { __typename?: 'RoleLabels', organization: string, administrator: string, organizer: string, guardian: string, attendee: string } | null, accessFields?: Array<{ __typename?: 'AccessField', key: string, field: { __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null } } | null> | null } | null, roleLabels?: { __typename?: 'RoleLabels', organization: string, administrator: string, organizer: string, guardian: string, attendee: string } | null, accessFields?: Array<{ __typename?: 'AccessField', key: string, field: { __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null } } | null> | null } };

export type TaxFragmentFragment = { __typename?: 'Tax', gst: any, gstLabel?: string | null, pst: any, pstLabel?: string | null, total: any };

export type TaxAndFeeEstimateFragmentFragment = { __typename?: 'TaxAndFeeEstimate', amountToCharge: any, serviceFee: any, method: FeeMethod, tax: { __typename?: 'Tax', gst: any, gstLabel?: string | null, pst: any, pstLabel?: string | null, total: any } };

export type TaxesAndFeesFragmentFragment = { __typename?: 'TaxesAndFees', amount: any, estimates: Array<{ __typename?: 'TaxAndFeeEstimate', amountToCharge: any, serviceFee: any, method: FeeMethod, tax: { __typename?: 'Tax', gst: any, gstLabel?: string | null, pst: any, pstLabel?: string | null, total: any } }>, typicalMethodEstimate: { __typename?: 'TaxAndFeeEstimate', amountToCharge: any, serviceFee: any, method: FeeMethod, tax: { __typename?: 'Tax', gst: any, gstLabel?: string | null, pst: any, pstLabel?: string | null, total: any } } };

export type TicketInventoryFragmentFragment = { __typename?: 'TicketInventory', initial?: number | null, isLimited: boolean, purchased: number, remaining?: number | null, ticketId: string };

export type TagFragmentFragment = { __typename?: 'Tag', id: string, displayName: string };

export type OrganizationInfoQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  countryCode: Scalars['String']['input'];
}>;


export type OrganizationInfoQuery = { __typename?: 'DomainQueries', Organization: { __typename?: 'Organization', id: string, isEnabled: boolean, name?: string | null, logo?: string | null, hasSafePay?: boolean | null, countryCode?: string | null, currencyCode?: string | null, disclaimer?: string | null, roleLabels?: { __typename?: 'RoleLabels', organization: string, administrator: string, organizer: string, guardian: string, attendee: string } | null, accessFields?: Array<{ __typename?: 'AccessField', key: string, field: { __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null } } | null> | null } };

export type OrganizationByHashQueryVariables = Exact<{
  hashedId: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
}>;


export type OrganizationByHashQuery = { __typename?: 'DomainQueries', OrganizationByHash: { __typename?: 'Organization', id: string, isEnabled: boolean, name?: string | null, logo?: string | null, hasSafePay?: boolean | null, countryCode?: string | null, currencyCode?: string | null, disclaimer?: string | null, roleLabels?: { __typename?: 'RoleLabels', organization: string, administrator: string, organizer: string, guardian: string, attendee: string } | null, accessFields?: Array<{ __typename?: 'AccessField', key: string, field: { __typename?: 'Field', id: string, type: FieldType, collapsable: boolean, readonly: boolean, question?: { __typename?: 'Question', id: string, name?: string | null, isRequired: boolean, labelText?: string | null, placeHolderText?: string | null, dataValue?: string | null, characterLimit?: number | null, format?: string | null, valueType?: string | null, valueOptions?: Array<string> | null, hidden: boolean, sortValueOptions: boolean, pinnedValueOptions?: Array<string> | null, minEntries?: number | null, maxEntries?: number | null, supportsApprovers?: boolean | null, plainLabel?: string | null } | null } } | null> | null } };

export type ResponseQueryVariables = Exact<{
  token: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
}>;


export type ResponseQuery = { __typename?: 'DomainQueries', Response: { __typename?: 'ResponseVersion', responseVersionId: string, documentVersionId: string, documentHashId: string, hash: string, completedByOrganizationName?: string | null, responseOrganizationId: string, isRostered: boolean, orderStatus: PaidStatus, isPaymentRequired: boolean, status: ResponseStatus, total: number, subTotal: number, signeeEmail?: string | null, signeeFirstName?: string | null, signeeLastName?: string | null, isSigned: boolean, isCheckedOut: boolean, createdDate: string, source: ResponseSource, sourceId?: string | null, isInternal?: boolean | null, isManual: boolean, signedDate?: string | null, signeeNotes?: string | null, signeeAttachmentId?: string | null, signeeAttachmentFileType?: string | null, originalValueUri?: string | null, tagId?: string | null, attendees: Array<{ __typename?: 'Attendee', responseAttendeeId: string, attendeeId: string, firstName?: string | null, lastName?: string | null, permitted?: boolean | null, manualPermissionDate?: string | null, attachmentId?: string | null, attachmentFileType?: string | null, notes?: string | null, tickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }>, attendeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, integratedDataOnFile?: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> | null }>, signeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, orders: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }>, previousOrders?: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }> | null } };

export type ResponseVersionsQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
}>;


export type ResponseVersionsQuery = { __typename?: 'DomainQueries', ResponseVersions: Array<{ __typename?: 'ResponseVersion', responseVersionId: string, documentVersionId: string, documentHashId: string, hash: string, completedByOrganizationName?: string | null, responseOrganizationId: string, isRostered: boolean, orderStatus: PaidStatus, isPaymentRequired: boolean, status: ResponseStatus, total: number, subTotal: number, signeeEmail?: string | null, signeeFirstName?: string | null, signeeLastName?: string | null, isSigned: boolean, isCheckedOut: boolean, createdDate: string, source: ResponseSource, sourceId?: string | null, isInternal?: boolean | null, isManual: boolean, signedDate?: string | null, signeeNotes?: string | null, signeeAttachmentId?: string | null, signeeAttachmentFileType?: string | null, originalValueUri?: string | null, tagId?: string | null, attendees: Array<{ __typename?: 'Attendee', responseAttendeeId: string, attendeeId: string, firstName?: string | null, lastName?: string | null, permitted?: boolean | null, manualPermissionDate?: string | null, attachmentId?: string | null, attachmentFileType?: string | null, notes?: string | null, tickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }>, attendeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, integratedDataOnFile?: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> | null }>, signeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, orders: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }>, previousOrders?: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }> | null }> };

export type StaffResponseVersionsQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
}>;


export type StaffResponseVersionsQuery = { __typename?: 'DomainQueries', StaffResponseVersions: Array<{ __typename?: 'ResponseVersion', responseVersionId: string, documentVersionId: string, documentHashId: string, hash: string, completedByOrganizationName?: string | null, responseOrganizationId: string, isRostered: boolean, orderStatus: PaidStatus, isPaymentRequired: boolean, status: ResponseStatus, total: number, subTotal: number, signeeEmail?: string | null, signeeFirstName?: string | null, signeeLastName?: string | null, isSigned: boolean, isCheckedOut: boolean, createdDate: string, source: ResponseSource, sourceId?: string | null, isInternal?: boolean | null, isManual: boolean, signedDate?: string | null, signeeNotes?: string | null, signeeAttachmentId?: string | null, signeeAttachmentFileType?: string | null, originalValueUri?: string | null, tagId?: string | null, attendees: Array<{ __typename?: 'Attendee', responseAttendeeId: string, attendeeId: string, firstName?: string | null, lastName?: string | null, permitted?: boolean | null, manualPermissionDate?: string | null, attachmentId?: string | null, attachmentFileType?: string | null, notes?: string | null, tickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }>, attendeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, integratedDataOnFile?: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> | null }>, signeeAnswers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }>, orders: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }>, previousOrders?: Array<{ __typename?: 'Order', orderId: string, canRefund?: boolean | null, wasManuallyPaid?: boolean | null, orderNumber: string, date: string, subTotal?: number | null, grandTotal?: number | null, grandTotalOriginal?: number | null, hasBeenPaid?: boolean | null, isRefunded?: boolean | null, isCheckedOut?: boolean | null, baseFee?: number | null, baseFeeString?: string | null, totalFees?: number | null, totalFeesString?: string | null, paymentTypes?: Array<string | null> | null, refundedAmount?: number | null, amountOutstanding?: number | null, purchaserFirstName?: string | null, purchaserLastName?: string | null, purchasedTickets: Array<{ __typename?: 'PurchasedTicket', name?: string | null, orderNumber: string, description?: string | null, price: number, totalPrice: number, quantity: number, createdDate?: string | null, sortOrder?: number | null, ticketId: string, ticketVersionId: string, purchasedTicketIds: Array<string>, attendeeId?: string | null, type: { __typename?: 'TicketTypeInfo', name?: string | null, id: number, defaultPrice: number, code?: string | null, sortOrder: number }, answers: Array<{ __typename?: 'Answer', answerId: string, value?: string | null, fieldId: string, fileType?: string | null, order?: number | null, questionId: string }> }> }> | null }> };

export type EligibleTagsQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
}>;


export type EligibleTagsQuery = { __typename?: 'DomainQueries', EligibleTags: Array<{ __typename?: 'Tag', id: string, displayName: string }> };

export type TaxesAndFeesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  passFeesToBuyer: Scalars['Boolean']['input'];
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
}>;


export type TaxesAndFeesQuery = { __typename?: 'DomainQueries', TaxesAndFees: { __typename?: 'TaxesAndFees', amount: any, estimates: Array<{ __typename?: 'TaxAndFeeEstimate', amountToCharge: any, serviceFee: any, method: FeeMethod, tax: { __typename?: 'Tax', gst: any, gstLabel?: string | null, pst: any, pstLabel?: string | null, total: any } }>, typicalMethodEstimate: { __typename?: 'TaxAndFeeEstimate', amountToCharge: any, serviceFee: any, method: FeeMethod, tax: { __typename?: 'Tax', gst: any, gstLabel?: string | null, pst: any, pstLabel?: string | null, total: any } } } };

export type TicketInventoryQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  ticketIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type TicketInventoryQuery = { __typename?: 'DomainQueries', TicketInventory: Array<{ __typename?: 'TicketInventory', initial?: number | null, isLimited: boolean, purchased: number, remaining?: number | null, ticketId: string }> };

export const FormAttachmentFragmentFragmentDoc = gql`
    fragment FormAttachmentFragment on Attachment {
  id
  friendlyName
  name
  isPdf
  contentUri
  thumbnailUri
  printUri
  downloadUri
  fileType
  readableFileSize
  mimeType
  isPdf
  isImage
  sizeInBytes
  isPrimary
}
    `;
export const LinkAttachmentFragmentFragmentDoc = gql`
    fragment LinkAttachmentFragment on LinkAttachment {
  id
  title
  description
  uri
  imageUri
  originalUri
}
    `;
export const FieldFragmentFragmentDoc = gql`
    fragment FieldFragment on Field {
  id
  type
  collapsable
  readonly
}
    `;
export const QuestionFragmentFragmentDoc = gql`
    fragment QuestionFragment on Question {
  id
  name
  isRequired
  labelText
  placeHolderText
  dataValue
  characterLimit
  format
  valueType
  valueOptions
  hidden
  sortValueOptions
  pinnedValueOptions
  minEntries
  maxEntries
  supportsApprovers
  plainLabel
}
    `;
export const TicketFragmentFragmentDoc = gql`
    fragment TicketFragment on Ticket {
  id
  name
  description
  startSellingDate
  endSellingDate
  imageId
  typeCode
  minimumQuantity
  maximumQuantity
  price
  passAlongFees
  ticketId
  documentVersionId
  formQuestionsId
  thumbnailUrl
  inventory {
    id
    isLimited
    remaining
    draftInitial
    draftRemaining
  }
  formQuestions {
    ...FieldFragment
    equationSections {
      ...QuestionFragment
    }
    question {
      ...QuestionFragment
    }
    fields {
      ...FieldFragment
      equationSections {
        ...QuestionFragment
      }
      question {
        ...QuestionFragment
      }
      fields {
        ...FieldFragment
        equationSections {
          ...QuestionFragment
        }
        question {
          ...QuestionFragment
        }
        fields {
          ...FieldFragment
          equationSections {
            ...QuestionFragment
          }
          question {
            ...QuestionFragment
          }
        }
      }
    }
  }
}
    ${FieldFragmentFragmentDoc}
${QuestionFragmentFragmentDoc}`;
export const TicketTypeFragmentFragmentDoc = gql`
    fragment TicketTypeFragment on TicketTypeInfo {
  name
  id
  defaultPrice
  code
  sortOrder
}
    `;
export const AnswerFragmentFragmentDoc = gql`
    fragment AnswerFragment on Answer {
  answerId
  value
  fieldId
  fileType
  order
  questionId
}
    `;
export const PurchasedTicketFragmentFragmentDoc = gql`
    fragment PurchasedTicketFragment on PurchasedTicket {
  type {
    ...TicketTypeFragment
  }
  name
  orderNumber
  description
  price
  totalPrice
  quantity
  createdDate
  sortOrder
  ticketId
  ticketVersionId
  purchasedTicketIds
  attendeeId
  answers {
    ...AnswerFragment
  }
}
    ${TicketTypeFragmentFragmentDoc}
${AnswerFragmentFragmentDoc}`;
export const AttendeeFragmentFragmentDoc = gql`
    fragment AttendeeFragment on Attendee {
  responseAttendeeId
  attendeeId
  firstName
  lastName
  permitted
  manualPermissionDate
  attachmentId
  attachmentFileType
  notes
  tickets {
    ...PurchasedTicketFragment
  }
  attendeeAnswers {
    ...AnswerFragment
  }
  integratedDataOnFile {
    ...AnswerFragment
  }
}
    ${PurchasedTicketFragmentFragmentDoc}
${AnswerFragmentFragmentDoc}`;
export const OrderFragmentFragmentDoc = gql`
    fragment OrderFragment on Order {
  orderId
  canRefund
  wasManuallyPaid
  orderNumber
  date
  subTotal
  grandTotal
  grandTotalOriginal
  hasBeenPaid
  isRefunded
  isCheckedOut
  baseFee
  baseFeeString
  totalFees
  totalFeesString
  paymentTypes
  refundedAmount
  amountOutstanding
  purchaserFirstName
  purchaserLastName
  purchasedTickets {
    ...PurchasedTicketFragment
  }
}
    ${PurchasedTicketFragmentFragmentDoc}`;
export const ResponseVersionFragmentFragmentDoc = gql`
    fragment ResponseVersionFragment on ResponseVersion {
  responseVersionId
  documentVersionId
  documentHashId
  hash
  completedByOrganizationName
  responseOrganizationId
  isRostered
  orderStatus
  isPaymentRequired
  status
  total
  subTotal
  signeeEmail
  signeeFirstName
  signeeLastName
  isSigned
  isCheckedOut
  createdDate
  attendees {
    ...AttendeeFragment
  }
  source
  sourceId
  isInternal
  isManual
  signedDate
  signeeNotes
  signeeAttachmentId
  signeeAttachmentFileType
  originalValueUri
  signeeAnswers {
    ...AnswerFragment
  }
  orders {
    ...OrderFragment
  }
  previousOrders {
    ...OrderFragment
  }
  hash
  tagId
}
    ${AttendeeFragmentFragmentDoc}
${AnswerFragmentFragmentDoc}
${OrderFragmentFragmentDoc}`;
export const IntegratedDataValueFragmentFragmentDoc = gql`
    fragment IntegratedDataValueFragment on IntegratedDataValue {
  value
  integratedDataFieldId
  profileId
}
    `;
export const OrganizationFragmentFragmentDoc = gql`
    fragment OrganizationFragment on Organization {
  id
  isEnabled
  name
  logo
  hasSafePay
  countryCode
  currencyCode
  disclaimer
  roleLabels {
    organization
    administrator
    organizer
    guardian
    attendee
  }
  accessFields {
    key
    field {
      ...FieldFragment
      question {
        ...QuestionFragment
      }
    }
  }
}
    ${FieldFragmentFragmentDoc}
${QuestionFragmentFragmentDoc}`;
export const DocumentFragmentFragmentDoc = gql`
    fragment DocumentFragment on Document {
  id
  disableResponseEditing
  disableAttendeeNameEditing
  showContactForm
  organization {
    ...OrganizationFragment
    parent {
      ...OrganizationFragment
    }
  }
}
    ${OrganizationFragmentFragmentDoc}`;
export const TaxFragmentFragmentDoc = gql`
    fragment TaxFragment on Tax {
  gst
  gstLabel
  pst
  pstLabel
  total
}
    `;
export const TaxAndFeeEstimateFragmentFragmentDoc = gql`
    fragment TaxAndFeeEstimateFragment on TaxAndFeeEstimate {
  amountToCharge
  serviceFee
  method
  tax {
    ...TaxFragment
  }
}
    ${TaxFragmentFragmentDoc}`;
export const TaxesAndFeesFragmentFragmentDoc = gql`
    fragment TaxesAndFeesFragment on TaxesAndFees {
  amount
  estimates {
    ...TaxAndFeeEstimateFragment
  }
  typicalMethodEstimate {
    ...TaxAndFeeEstimateFragment
  }
}
    ${TaxAndFeeEstimateFragmentFragmentDoc}`;
export const TicketInventoryFragmentFragmentDoc = gql`
    fragment TicketInventoryFragment on TicketInventory {
  initial
  isLimited
  purchased
  remaining
  ticketId
}
    `;
export const TagFragmentFragmentDoc = gql`
    fragment TagFragment on Tag {
  id
  displayName
}
    `;
export const SaveSigneeAnswerDocument = gql`
    mutation SaveSigneeAnswer($countryCode: String!, $documentId: ID!, $answer: AnswerInput!, $responseVersionId: ID!, $accessData: [AccessDataInput!]!) {
  SaveSigneeAnswer(
    countryCode: $countryCode
    documentId: $documentId
    answer: $answer
    accessData: $accessData
    responseVersionId: $responseVersionId
  ) {
    ...AnswerFragment
  }
}
    ${AnswerFragmentFragmentDoc}`;
export type SaveSigneeAnswerMutationFn = Apollo.MutationFunction<SaveSigneeAnswerMutation, SaveSigneeAnswerMutationVariables>;

/**
 * __useSaveSigneeAnswerMutation__
 *
 * To run a mutation, you first call `useSaveSigneeAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSigneeAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSigneeAnswerMutation, { data, loading, error }] = useSaveSigneeAnswerMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      answer: // value for 'answer'
 *      responseVersionId: // value for 'responseVersionId'
 *      accessData: // value for 'accessData'
 *   },
 * });
 */
export function useSaveSigneeAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SaveSigneeAnswerMutation, SaveSigneeAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSigneeAnswerMutation, SaveSigneeAnswerMutationVariables>(SaveSigneeAnswerDocument, options);
      }
export type SaveSigneeAnswerMutationHookResult = ReturnType<typeof useSaveSigneeAnswerMutation>;
export type SaveSigneeAnswerMutationResult = Apollo.MutationResult<SaveSigneeAnswerMutation>;
export type SaveSigneeAnswerMutationOptions = Apollo.BaseMutationOptions<SaveSigneeAnswerMutation, SaveSigneeAnswerMutationVariables>;
export const DeleteSigneeAnswerDocument = gql`
    mutation DeleteSigneeAnswer($countryCode: String!, $documentId: ID!, $responseVersionId: ID!, $answerInput: DeleteAnswerInput!, $accessData: [AccessDataInput!]!) {
  DeleteSigneeAnswer(
    countryCode: $countryCode
    documentId: $documentId
    responseVersionId: $responseVersionId
    answerInput: $answerInput
    accessData: $accessData
  )
}
    `;
export type DeleteSigneeAnswerMutationFn = Apollo.MutationFunction<DeleteSigneeAnswerMutation, DeleteSigneeAnswerMutationVariables>;

/**
 * __useDeleteSigneeAnswerMutation__
 *
 * To run a mutation, you first call `useDeleteSigneeAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSigneeAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSigneeAnswerMutation, { data, loading, error }] = useDeleteSigneeAnswerMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      responseVersionId: // value for 'responseVersionId'
 *      answerInput: // value for 'answerInput'
 *      accessData: // value for 'accessData'
 *   },
 * });
 */
export function useDeleteSigneeAnswerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSigneeAnswerMutation, DeleteSigneeAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSigneeAnswerMutation, DeleteSigneeAnswerMutationVariables>(DeleteSigneeAnswerDocument, options);
      }
export type DeleteSigneeAnswerMutationHookResult = ReturnType<typeof useDeleteSigneeAnswerMutation>;
export type DeleteSigneeAnswerMutationResult = Apollo.MutationResult<DeleteSigneeAnswerMutation>;
export type DeleteSigneeAnswerMutationOptions = Apollo.BaseMutationOptions<DeleteSigneeAnswerMutation, DeleteSigneeAnswerMutationVariables>;
export const SaveAttendeeAnswerDocument = gql`
    mutation SaveAttendeeAnswer($countryCode: String!, $documentId: ID!, $answer: AnswerInput!, $responseVersionId: ID!, $attendeeId: ID!, $accessData: [AccessDataInput!]!) {
  SaveAttendeeAnswer(
    countryCode: $countryCode
    documentId: $documentId
    answer: $answer
    responseVersionId: $responseVersionId
    attendeeId: $attendeeId
    accessData: $accessData
  ) {
    ...AnswerFragment
  }
}
    ${AnswerFragmentFragmentDoc}`;
export type SaveAttendeeAnswerMutationFn = Apollo.MutationFunction<SaveAttendeeAnswerMutation, SaveAttendeeAnswerMutationVariables>;

/**
 * __useSaveAttendeeAnswerMutation__
 *
 * To run a mutation, you first call `useSaveAttendeeAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAttendeeAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAttendeeAnswerMutation, { data, loading, error }] = useSaveAttendeeAnswerMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      answer: // value for 'answer'
 *      responseVersionId: // value for 'responseVersionId'
 *      attendeeId: // value for 'attendeeId'
 *      accessData: // value for 'accessData'
 *   },
 * });
 */
export function useSaveAttendeeAnswerMutation(baseOptions?: Apollo.MutationHookOptions<SaveAttendeeAnswerMutation, SaveAttendeeAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAttendeeAnswerMutation, SaveAttendeeAnswerMutationVariables>(SaveAttendeeAnswerDocument, options);
      }
export type SaveAttendeeAnswerMutationHookResult = ReturnType<typeof useSaveAttendeeAnswerMutation>;
export type SaveAttendeeAnswerMutationResult = Apollo.MutationResult<SaveAttendeeAnswerMutation>;
export type SaveAttendeeAnswerMutationOptions = Apollo.BaseMutationOptions<SaveAttendeeAnswerMutation, SaveAttendeeAnswerMutationVariables>;
export const DeleteAttendeeAnswerDocument = gql`
    mutation DeleteAttendeeAnswer($countryCode: String!, $documentId: ID!, $responseVersionId: ID!, $answerInput: DeleteAnswerInput!, $attendeeId: ID!, $accessData: [AccessDataInput!]!) {
  DeleteAttendeeAnswer(
    countryCode: $countryCode
    documentId: $documentId
    responseVersionId: $responseVersionId
    answerInput: $answerInput
    attendeeId: $attendeeId
    accessData: $accessData
  )
}
    `;
export type DeleteAttendeeAnswerMutationFn = Apollo.MutationFunction<DeleteAttendeeAnswerMutation, DeleteAttendeeAnswerMutationVariables>;

/**
 * __useDeleteAttendeeAnswerMutation__
 *
 * To run a mutation, you first call `useDeleteAttendeeAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttendeeAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttendeeAnswerMutation, { data, loading, error }] = useDeleteAttendeeAnswerMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      responseVersionId: // value for 'responseVersionId'
 *      answerInput: // value for 'answerInput'
 *      attendeeId: // value for 'attendeeId'
 *      accessData: // value for 'accessData'
 *   },
 * });
 */
export function useDeleteAttendeeAnswerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttendeeAnswerMutation, DeleteAttendeeAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttendeeAnswerMutation, DeleteAttendeeAnswerMutationVariables>(DeleteAttendeeAnswerDocument, options);
      }
export type DeleteAttendeeAnswerMutationHookResult = ReturnType<typeof useDeleteAttendeeAnswerMutation>;
export type DeleteAttendeeAnswerMutationResult = Apollo.MutationResult<DeleteAttendeeAnswerMutation>;
export type DeleteAttendeeAnswerMutationOptions = Apollo.BaseMutationOptions<DeleteAttendeeAnswerMutation, DeleteAttendeeAnswerMutationVariables>;
export const EditAttendeesDocument = gql`
    mutation EditAttendees($countryCode: String!, $documentId: ID!, $responseVersionId: ID!, $attendees: [AttendeeInput!]!, $accessData: [AccessDataInput!]!) {
  EditAttendees(
    countryCode: $countryCode
    documentId: $documentId
    responseVersionId: $responseVersionId
    attendees: $attendees
    accessData: $accessData
  ) {
    responseAttendeeId
    attendeeId
    firstName
    lastName
    permitted
    manualPermissionDate
    attachmentId
    attachmentFileType
    notes
  }
}
    `;
export type EditAttendeesMutationFn = Apollo.MutationFunction<EditAttendeesMutation, EditAttendeesMutationVariables>;

/**
 * __useEditAttendeesMutation__
 *
 * To run a mutation, you first call `useEditAttendeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAttendeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAttendeesMutation, { data, loading, error }] = useEditAttendeesMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      responseVersionId: // value for 'responseVersionId'
 *      attendees: // value for 'attendees'
 *      accessData: // value for 'accessData'
 *   },
 * });
 */
export function useEditAttendeesMutation(baseOptions?: Apollo.MutationHookOptions<EditAttendeesMutation, EditAttendeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAttendeesMutation, EditAttendeesMutationVariables>(EditAttendeesDocument, options);
      }
export type EditAttendeesMutationHookResult = ReturnType<typeof useEditAttendeesMutation>;
export type EditAttendeesMutationResult = Apollo.MutationResult<EditAttendeesMutation>;
export type EditAttendeesMutationOptions = Apollo.BaseMutationOptions<EditAttendeesMutation, EditAttendeesMutationVariables>;
export const CreateOrResumeResponseDocument = gql`
    mutation CreateOrResumeResponse($countryCode: String!, $documentId: ID!, $signee: SigneeInput!, $organizationHash: String, $responseVersionId: ID, $accessData: [AccessDataInput!]!) {
  CreateOrResumeResponse(
    countryCode: $countryCode
    documentId: $documentId
    signee: $signee
    organizationHash: $organizationHash
    responseVersionId: $responseVersionId
    accessData: $accessData
  ) {
    ...ResponseVersionFragment
    __typename
  }
}
    ${ResponseVersionFragmentFragmentDoc}`;
export type CreateOrResumeResponseMutationFn = Apollo.MutationFunction<CreateOrResumeResponseMutation, CreateOrResumeResponseMutationVariables>;

/**
 * __useCreateOrResumeResponseMutation__
 *
 * To run a mutation, you first call `useCreateOrResumeResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrResumeResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrResumeResponseMutation, { data, loading, error }] = useCreateOrResumeResponseMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      signee: // value for 'signee'
 *      organizationHash: // value for 'organizationHash'
 *      responseVersionId: // value for 'responseVersionId'
 *      accessData: // value for 'accessData'
 *   },
 * });
 */
export function useCreateOrResumeResponseMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrResumeResponseMutation, CreateOrResumeResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrResumeResponseMutation, CreateOrResumeResponseMutationVariables>(CreateOrResumeResponseDocument, options);
      }
export type CreateOrResumeResponseMutationHookResult = ReturnType<typeof useCreateOrResumeResponseMutation>;
export type CreateOrResumeResponseMutationResult = Apollo.MutationResult<CreateOrResumeResponseMutation>;
export type CreateOrResumeResponseMutationOptions = Apollo.BaseMutationOptions<CreateOrResumeResponseMutation, CreateOrResumeResponseMutationVariables>;
export const CreateResponseDocument = gql`
    mutation CreateResponse($countryCode: String!, $documentId: ID!, $signee: SigneeInput!, $organizationHash: String, $organizationId: ID, $responseVersionId: ID, $accessData: [AccessDataInput!]!) {
  CreateResponse(
    countryCode: $countryCode
    documentId: $documentId
    signee: $signee
    organizationHash: $organizationHash
    organizationId: $organizationId
    responseVersionId: $responseVersionId
    accessData: $accessData
  ) {
    ...ResponseVersionFragment
    __typename
  }
}
    ${ResponseVersionFragmentFragmentDoc}`;
export type CreateResponseMutationFn = Apollo.MutationFunction<CreateResponseMutation, CreateResponseMutationVariables>;

/**
 * __useCreateResponseMutation__
 *
 * To run a mutation, you first call `useCreateResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResponseMutation, { data, loading, error }] = useCreateResponseMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      signee: // value for 'signee'
 *      organizationHash: // value for 'organizationHash'
 *      organizationId: // value for 'organizationId'
 *      responseVersionId: // value for 'responseVersionId'
 *      accessData: // value for 'accessData'
 *   },
 * });
 */
export function useCreateResponseMutation(baseOptions?: Apollo.MutationHookOptions<CreateResponseMutation, CreateResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResponseMutation, CreateResponseMutationVariables>(CreateResponseDocument, options);
      }
export type CreateResponseMutationHookResult = ReturnType<typeof useCreateResponseMutation>;
export type CreateResponseMutationResult = Apollo.MutationResult<CreateResponseMutation>;
export type CreateResponseMutationOptions = Apollo.BaseMutationOptions<CreateResponseMutation, CreateResponseMutationVariables>;
export const RestartResponseDocument = gql`
    mutation RestartResponse($countryCode: String!, $documentId: ID!, $responseVersionId: ID!) {
  RestartResponse(
    countryCode: $countryCode
    documentId: $documentId
    responseVersionId: $responseVersionId
  ) {
    ...ResponseVersionFragment
    __typename
  }
}
    ${ResponseVersionFragmentFragmentDoc}`;
export type RestartResponseMutationFn = Apollo.MutationFunction<RestartResponseMutation, RestartResponseMutationVariables>;

/**
 * __useRestartResponseMutation__
 *
 * To run a mutation, you first call `useRestartResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestartResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restartResponseMutation, { data, loading, error }] = useRestartResponseMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      responseVersionId: // value for 'responseVersionId'
 *   },
 * });
 */
export function useRestartResponseMutation(baseOptions?: Apollo.MutationHookOptions<RestartResponseMutation, RestartResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestartResponseMutation, RestartResponseMutationVariables>(RestartResponseDocument, options);
      }
export type RestartResponseMutationHookResult = ReturnType<typeof useRestartResponseMutation>;
export type RestartResponseMutationResult = Apollo.MutationResult<RestartResponseMutation>;
export type RestartResponseMutationOptions = Apollo.BaseMutationOptions<RestartResponseMutation, RestartResponseMutationVariables>;
export const RestartInProcessResponseDocument = gql`
    mutation RestartInProcessResponse($countryCode: String!, $documentId: ID!, $responseVersionId: ID!) {
  RestartInProcessResponse(
    countryCode: $countryCode
    documentId: $documentId
    responseVersionId: $responseVersionId
  ) {
    ...ResponseVersionFragment
    __typename
  }
}
    ${ResponseVersionFragmentFragmentDoc}`;
export type RestartInProcessResponseMutationFn = Apollo.MutationFunction<RestartInProcessResponseMutation, RestartInProcessResponseMutationVariables>;

/**
 * __useRestartInProcessResponseMutation__
 *
 * To run a mutation, you first call `useRestartInProcessResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestartInProcessResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restartInProcessResponseMutation, { data, loading, error }] = useRestartInProcessResponseMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      responseVersionId: // value for 'responseVersionId'
 *   },
 * });
 */
export function useRestartInProcessResponseMutation(baseOptions?: Apollo.MutationHookOptions<RestartInProcessResponseMutation, RestartInProcessResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestartInProcessResponseMutation, RestartInProcessResponseMutationVariables>(RestartInProcessResponseDocument, options);
      }
export type RestartInProcessResponseMutationHookResult = ReturnType<typeof useRestartInProcessResponseMutation>;
export type RestartInProcessResponseMutationResult = Apollo.MutationResult<RestartInProcessResponseMutation>;
export type RestartInProcessResponseMutationOptions = Apollo.BaseMutationOptions<RestartInProcessResponseMutation, RestartInProcessResponseMutationVariables>;
export const AddResponseVersionDocument = gql`
    mutation AddResponseVersion($countryCode: String!, $documentId: ID!, $responseVersionId: ID!) {
  AddResponseVersion(
    countryCode: $countryCode
    documentId: $documentId
    responseVersionId: $responseVersionId
  ) {
    ...ResponseVersionFragment
    __typename
  }
}
    ${ResponseVersionFragmentFragmentDoc}`;
export type AddResponseVersionMutationFn = Apollo.MutationFunction<AddResponseVersionMutation, AddResponseVersionMutationVariables>;

/**
 * __useAddResponseVersionMutation__
 *
 * To run a mutation, you first call `useAddResponseVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddResponseVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addResponseVersionMutation, { data, loading, error }] = useAddResponseVersionMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      responseVersionId: // value for 'responseVersionId'
 *   },
 * });
 */
export function useAddResponseVersionMutation(baseOptions?: Apollo.MutationHookOptions<AddResponseVersionMutation, AddResponseVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddResponseVersionMutation, AddResponseVersionMutationVariables>(AddResponseVersionDocument, options);
      }
export type AddResponseVersionMutationHookResult = ReturnType<typeof useAddResponseVersionMutation>;
export type AddResponseVersionMutationResult = Apollo.MutationResult<AddResponseVersionMutation>;
export type AddResponseVersionMutationOptions = Apollo.BaseMutationOptions<AddResponseVersionMutation, AddResponseVersionMutationVariables>;
export const UpdateResponseVersionDocument = gql`
    mutation UpdateResponseVersion($countryCode: String!, $documentId: ID!, $responseVersionId: ID!) {
  UpdateResponseVersion(
    countryCode: $countryCode
    documentId: $documentId
    responseVersionId: $responseVersionId
  ) {
    ...ResponseVersionFragment
    __typename
  }
}
    ${ResponseVersionFragmentFragmentDoc}`;
export type UpdateResponseVersionMutationFn = Apollo.MutationFunction<UpdateResponseVersionMutation, UpdateResponseVersionMutationVariables>;

/**
 * __useUpdateResponseVersionMutation__
 *
 * To run a mutation, you first call `useUpdateResponseVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResponseVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResponseVersionMutation, { data, loading, error }] = useUpdateResponseVersionMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      responseVersionId: // value for 'responseVersionId'
 *   },
 * });
 */
export function useUpdateResponseVersionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResponseVersionMutation, UpdateResponseVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResponseVersionMutation, UpdateResponseVersionMutationVariables>(UpdateResponseVersionDocument, options);
      }
export type UpdateResponseVersionMutationHookResult = ReturnType<typeof useUpdateResponseVersionMutation>;
export type UpdateResponseVersionMutationResult = Apollo.MutationResult<UpdateResponseVersionMutation>;
export type UpdateResponseVersionMutationOptions = Apollo.BaseMutationOptions<UpdateResponseVersionMutation, UpdateResponseVersionMutationVariables>;
export const ValidateAccessDocument = gql`
    mutation ValidateAccess($countryCode: String!, $documentId: ID!, $accessData: [AccessDataInput!]!, $responseVersionId: ID!) {
  ValidateAccess(
    countryCode: $countryCode
    documentId: $documentId
    accessData: $accessData
    responseVersionId: $responseVersionId
  )
}
    `;
export type ValidateAccessMutationFn = Apollo.MutationFunction<ValidateAccessMutation, ValidateAccessMutationVariables>;

/**
 * __useValidateAccessMutation__
 *
 * To run a mutation, you first call `useValidateAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAccessMutation, { data, loading, error }] = useValidateAccessMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      accessData: // value for 'accessData'
 *      responseVersionId: // value for 'responseVersionId'
 *   },
 * });
 */
export function useValidateAccessMutation(baseOptions?: Apollo.MutationHookOptions<ValidateAccessMutation, ValidateAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateAccessMutation, ValidateAccessMutationVariables>(ValidateAccessDocument, options);
      }
export type ValidateAccessMutationHookResult = ReturnType<typeof useValidateAccessMutation>;
export type ValidateAccessMutationResult = Apollo.MutationResult<ValidateAccessMutation>;
export type ValidateAccessMutationOptions = Apollo.BaseMutationOptions<ValidateAccessMutation, ValidateAccessMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($documentId: ID!, $countryCode: String!, $tagId: ID, $responseVersionId: ID!) {
  UpdateTag(
    documentId: $documentId
    countryCode: $countryCode
    tagId: $tagId
    responseVersionId: $responseVersionId
  )
}
    `;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      countryCode: // value for 'countryCode'
 *      tagId: // value for 'tagId'
 *      responseVersionId: // value for 'responseVersionId'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const AcceptTermsDocument = gql`
    mutation AcceptTerms($countryCode: String!, $documentId: ID!, $responseVersionId: ID!, $accessData: [AccessDataInput!], $paymentToken: String, $orderId: ID, $languageCode: String) {
  AcceptTerms(
    countryCode: $countryCode
    documentId: $documentId
    responseVersionId: $responseVersionId
    accessData: $accessData
    paymentToken: $paymentToken
    orderId: $orderId
    languageCode: $languageCode
  )
}
    `;
export type AcceptTermsMutationFn = Apollo.MutationFunction<AcceptTermsMutation, AcceptTermsMutationVariables>;

/**
 * __useAcceptTermsMutation__
 *
 * To run a mutation, you first call `useAcceptTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsMutation, { data, loading, error }] = useAcceptTermsMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      responseVersionId: // value for 'responseVersionId'
 *      accessData: // value for 'accessData'
 *      paymentToken: // value for 'paymentToken'
 *      orderId: // value for 'orderId'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useAcceptTermsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTermsMutation, AcceptTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTermsMutation, AcceptTermsMutationVariables>(AcceptTermsDocument, options);
      }
export type AcceptTermsMutationHookResult = ReturnType<typeof useAcceptTermsMutation>;
export type AcceptTermsMutationResult = Apollo.MutationResult<AcceptTermsMutation>;
export type AcceptTermsMutationOptions = Apollo.BaseMutationOptions<AcceptTermsMutation, AcceptTermsMutationVariables>;
export const SignUpForNotificationDocument = gql`
    mutation SignUpForNotification($countryCode: String!, $email: String!, $documentVersionId: ID!) {
  SignUpForNotification(
    countryCode: $countryCode
    email: $email
    documentVersionId: $documentVersionId
  )
}
    `;
export type SignUpForNotificationMutationFn = Apollo.MutationFunction<SignUpForNotificationMutation, SignUpForNotificationMutationVariables>;

/**
 * __useSignUpForNotificationMutation__
 *
 * To run a mutation, you first call `useSignUpForNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpForNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpForNotificationMutation, { data, loading, error }] = useSignUpForNotificationMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      email: // value for 'email'
 *      documentVersionId: // value for 'documentVersionId'
 *   },
 * });
 */
export function useSignUpForNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SignUpForNotificationMutation, SignUpForNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpForNotificationMutation, SignUpForNotificationMutationVariables>(SignUpForNotificationDocument, options);
      }
export type SignUpForNotificationMutationHookResult = ReturnType<typeof useSignUpForNotificationMutation>;
export type SignUpForNotificationMutationResult = Apollo.MutationResult<SignUpForNotificationMutation>;
export type SignUpForNotificationMutationOptions = Apollo.BaseMutationOptions<SignUpForNotificationMutation, SignUpForNotificationMutationVariables>;
export const SubmitFeedbackDocument = gql`
    mutation SubmitFeedback($countryCode: String!, $documentVersionId: ID!, $responseVersionId: ID!, $feedback: String!, $signeeEmailAddress: String!, $signeeFirstName: String!, $signeeLastName: String!) {
  SubmitFeedback(
    countryCode: $countryCode
    documentVersionId: $documentVersionId
    responseVersionId: $responseVersionId
    feedback: $feedback
    signeeEmailAddress: $signeeEmailAddress
    signeeFirstName: $signeeFirstName
    signeeLastName: $signeeLastName
  )
}
    `;
export type SubmitFeedbackMutationFn = Apollo.MutationFunction<SubmitFeedbackMutation, SubmitFeedbackMutationVariables>;

/**
 * __useSubmitFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFeedbackMutation, { data, loading, error }] = useSubmitFeedbackMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentVersionId: // value for 'documentVersionId'
 *      responseVersionId: // value for 'responseVersionId'
 *      feedback: // value for 'feedback'
 *      signeeEmailAddress: // value for 'signeeEmailAddress'
 *      signeeFirstName: // value for 'signeeFirstName'
 *      signeeLastName: // value for 'signeeLastName'
 *   },
 * });
 */
export function useSubmitFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFeedbackMutation, SubmitFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFeedbackMutation, SubmitFeedbackMutationVariables>(SubmitFeedbackDocument, options);
      }
export type SubmitFeedbackMutationHookResult = ReturnType<typeof useSubmitFeedbackMutation>;
export type SubmitFeedbackMutationResult = Apollo.MutationResult<SubmitFeedbackMutation>;
export type SubmitFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitFeedbackMutation, SubmitFeedbackMutationVariables>;
export const ReserveTicketDocument = gql`
    mutation ReserveTicket($countryCode: String!, $documentId: ID!, $responseVersionId: ID!, $responseAttendeeId: ID!, $ticketVersionId: ID!, $reserveTicketInput: ReserveTicketInput!) {
  ReserveTicket(
    countryCode: $countryCode
    documentId: $documentId
    responseVersionId: $responseVersionId
    responseAttendeeId: $responseAttendeeId
    ticketVersionId: $ticketVersionId
    reserveTicketInput: $reserveTicketInput
  )
}
    `;
export type ReserveTicketMutationFn = Apollo.MutationFunction<ReserveTicketMutation, ReserveTicketMutationVariables>;

/**
 * __useReserveTicketMutation__
 *
 * To run a mutation, you first call `useReserveTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReserveTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reserveTicketMutation, { data, loading, error }] = useReserveTicketMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      responseVersionId: // value for 'responseVersionId'
 *      responseAttendeeId: // value for 'responseAttendeeId'
 *      ticketVersionId: // value for 'ticketVersionId'
 *      reserveTicketInput: // value for 'reserveTicketInput'
 *   },
 * });
 */
export function useReserveTicketMutation(baseOptions?: Apollo.MutationHookOptions<ReserveTicketMutation, ReserveTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReserveTicketMutation, ReserveTicketMutationVariables>(ReserveTicketDocument, options);
      }
export type ReserveTicketMutationHookResult = ReturnType<typeof useReserveTicketMutation>;
export type ReserveTicketMutationResult = Apollo.MutationResult<ReserveTicketMutation>;
export type ReserveTicketMutationOptions = Apollo.BaseMutationOptions<ReserveTicketMutation, ReserveTicketMutationVariables>;
export const CancelTicketDocument = gql`
    mutation CancelTicket($countryCode: String!, $documentId: ID!, $responseVersionId: ID!, $responseAttendeeId: ID!, $ticketVersionId: ID!, $purchasedTicketIds: [ID!]!, $orderId: ID!) {
  CancelTicket(
    countryCode: $countryCode
    documentId: $documentId
    responseVersionId: $responseVersionId
    responseAttendeeId: $responseAttendeeId
    ticketVersionId: $ticketVersionId
    purchasedTicketIds: $purchasedTicketIds
    orderId: $orderId
  )
}
    `;
export type CancelTicketMutationFn = Apollo.MutationFunction<CancelTicketMutation, CancelTicketMutationVariables>;

/**
 * __useCancelTicketMutation__
 *
 * To run a mutation, you first call `useCancelTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTicketMutation, { data, loading, error }] = useCancelTicketMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      responseVersionId: // value for 'responseVersionId'
 *      responseAttendeeId: // value for 'responseAttendeeId'
 *      ticketVersionId: // value for 'ticketVersionId'
 *      purchasedTicketIds: // value for 'purchasedTicketIds'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useCancelTicketMutation(baseOptions?: Apollo.MutationHookOptions<CancelTicketMutation, CancelTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelTicketMutation, CancelTicketMutationVariables>(CancelTicketDocument, options);
      }
export type CancelTicketMutationHookResult = ReturnType<typeof useCancelTicketMutation>;
export type CancelTicketMutationResult = Apollo.MutationResult<CancelTicketMutation>;
export type CancelTicketMutationOptions = Apollo.BaseMutationOptions<CancelTicketMutation, CancelTicketMutationVariables>;
export const FormInfoDocument = gql`
    query FormInfo($token: String!, $countryCode: String!, $hashedOrgId: String) {
  Form(token: $token, countryCode: $countryCode, hashedOrgId: $hashedOrgId) {
    id
    name
    status
    redirectUrl
    documentId
    redirectMessage
    allowMultipleChildrenOnOneOrder
    allowOnlinePaymentsOnly
    respondentMustSelectATicket
    manualPaymentText
    parentMessage
    information
    organizerName
    requiresPermission
    isGeneralSignup
    restrictResponses
    hasApprovers
    hasReachedResponseCutOffDate
    responseCutOffLocalDate
    startDate
    endDate
    affirmativePermission
    negativePermission
    useOrganizationBranding
    useLocalTranslations
    document {
      ...DocumentFragment
    }
    attachments {
      ...FormAttachmentFragment
    }
    linkAttachments {
      ...LinkAttachmentFragment
    }
    publicQuestions {
      ...FieldFragment
      equationSections {
        ...QuestionFragment
      }
      question {
        ...QuestionFragment
      }
      fields {
        ...FieldFragment
        equationSections {
          ...QuestionFragment
        }
        question {
          ...QuestionFragment
        }
        fields {
          ...FieldFragment
          equationSections {
            ...QuestionFragment
          }
          question {
            ...QuestionFragment
          }
          fields {
            ...FieldFragment
            equationSections {
              ...QuestionFragment
            }
            question {
              ...QuestionFragment
            }
          }
        }
      }
    }
    publicOrganizerAnswers {
      ...AnswerFragment
    }
    signeeQuestions {
      ...FieldFragment
      equationSections {
        ...QuestionFragment
      }
      question {
        ...QuestionFragment
      }
      fields {
        ...FieldFragment
        equationSections {
          ...QuestionFragment
        }
        question {
          ...QuestionFragment
        }
        fields {
          ...FieldFragment
          equationSections {
            ...QuestionFragment
          }
          question {
            ...QuestionFragment
          }
          fields {
            ...FieldFragment
            equationSections {
              ...QuestionFragment
            }
            question {
              ...QuestionFragment
            }
          }
        }
      }
    }
    attendeeQuestions {
      ...FieldFragment
      equationSections {
        ...QuestionFragment
      }
      question {
        ...QuestionFragment
      }
      fields {
        ...FieldFragment
        equationSections {
          ...QuestionFragment
        }
        question {
          ...QuestionFragment
        }
        fields {
          ...FieldFragment
          equationSections {
            ...QuestionFragment
          }
          question {
            ...QuestionFragment
          }
          fields {
            ...FieldFragment
            equationSections {
              ...QuestionFragment
            }
            question {
              ...QuestionFragment
            }
          }
        }
      }
    }
    tickets {
      ...TicketFragment
    }
    template {
      attachmentsPermissions
      ticketPermissions
      signeeFormPermissions
      attendeeFormPermissions
      document {
        ...DocumentFragment
      }
      attachments {
        ...FormAttachmentFragment
      }
      linkAttachments {
        ...LinkAttachmentFragment
      }
      publicQuestions {
        ...FieldFragment
        equationSections {
          ...QuestionFragment
        }
        question {
          ...QuestionFragment
        }
        fields {
          ...FieldFragment
          equationSections {
            ...QuestionFragment
          }
          question {
            ...QuestionFragment
          }
          fields {
            ...FieldFragment
            equationSections {
              ...QuestionFragment
            }
            question {
              ...QuestionFragment
            }
            fields {
              ...FieldFragment
              equationSections {
                ...QuestionFragment
              }
              question {
                ...QuestionFragment
              }
            }
          }
        }
      }
      signeeQuestions {
        ...FieldFragment
        equationSections {
          ...QuestionFragment
        }
        question {
          ...QuestionFragment
        }
        fields {
          ...FieldFragment
          equationSections {
            ...QuestionFragment
          }
          question {
            ...QuestionFragment
          }
          fields {
            ...FieldFragment
            equationSections {
              ...QuestionFragment
            }
            question {
              ...QuestionFragment
            }
            fields {
              ...FieldFragment
              equationSections {
                ...QuestionFragment
              }
              question {
                ...QuestionFragment
              }
            }
          }
        }
      }
      attendeeQuestions {
        ...FieldFragment
        equationSections {
          ...QuestionFragment
        }
        question {
          ...QuestionFragment
        }
        fields {
          ...FieldFragment
          equationSections {
            ...QuestionFragment
          }
          question {
            ...QuestionFragment
          }
          fields {
            ...FieldFragment
            equationSections {
              ...QuestionFragment
            }
            question {
              ...QuestionFragment
            }
            fields {
              ...FieldFragment
              equationSections {
                ...QuestionFragment
              }
              question {
                ...QuestionFragment
              }
            }
          }
        }
      }
      tickets {
        ...TicketFragment
      }
    }
  }
}
    ${DocumentFragmentFragmentDoc}
${FormAttachmentFragmentFragmentDoc}
${LinkAttachmentFragmentFragmentDoc}
${FieldFragmentFragmentDoc}
${QuestionFragmentFragmentDoc}
${AnswerFragmentFragmentDoc}
${TicketFragmentFragmentDoc}`;

/**
 * __useFormInfoQuery__
 *
 * To run a query within a React component, call `useFormInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormInfoQuery({
 *   variables: {
 *      token: // value for 'token'
 *      countryCode: // value for 'countryCode'
 *      hashedOrgId: // value for 'hashedOrgId'
 *   },
 * });
 */
export function useFormInfoQuery(baseOptions: Apollo.QueryHookOptions<FormInfoQuery, FormInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormInfoQuery, FormInfoQueryVariables>(FormInfoDocument, options);
      }
export function useFormInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormInfoQuery, FormInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormInfoQuery, FormInfoQueryVariables>(FormInfoDocument, options);
        }
export type FormInfoQueryHookResult = ReturnType<typeof useFormInfoQuery>;
export type FormInfoLazyQueryHookResult = ReturnType<typeof useFormInfoLazyQuery>;
export type FormInfoQueryResult = Apollo.QueryResult<FormInfoQuery, FormInfoQueryVariables>;
export const FormByHashDocument = gql`
    query FormByHash($hashedId: String!, $countryCode: String!) {
  FormByHash(hashedId: $hashedId, countryCode: $countryCode) {
    isRetired
  }
}
    `;

/**
 * __useFormByHashQuery__
 *
 * To run a query within a React component, call `useFormByHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormByHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormByHashQuery({
 *   variables: {
 *      hashedId: // value for 'hashedId'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useFormByHashQuery(baseOptions: Apollo.QueryHookOptions<FormByHashQuery, FormByHashQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormByHashQuery, FormByHashQueryVariables>(FormByHashDocument, options);
      }
export function useFormByHashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormByHashQuery, FormByHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormByHashQuery, FormByHashQueryVariables>(FormByHashDocument, options);
        }
export type FormByHashQueryHookResult = ReturnType<typeof useFormByHashQuery>;
export type FormByHashLazyQueryHookResult = ReturnType<typeof useFormByHashLazyQuery>;
export type FormByHashQueryResult = Apollo.QueryResult<FormByHashQuery, FormByHashQueryVariables>;
export const ResponseByHashDocument = gql`
    query ResponseByHash($hashedId: String!) {
  ResponseByHash(hashedId: $hashedId) {
    isRetired
  }
}
    `;

/**
 * __useResponseByHashQuery__
 *
 * To run a query within a React component, call `useResponseByHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useResponseByHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResponseByHashQuery({
 *   variables: {
 *      hashedId: // value for 'hashedId'
 *   },
 * });
 */
export function useResponseByHashQuery(baseOptions: Apollo.QueryHookOptions<ResponseByHashQuery, ResponseByHashQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResponseByHashQuery, ResponseByHashQueryVariables>(ResponseByHashDocument, options);
      }
export function useResponseByHashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResponseByHashQuery, ResponseByHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResponseByHashQuery, ResponseByHashQueryVariables>(ResponseByHashDocument, options);
        }
export type ResponseByHashQueryHookResult = ReturnType<typeof useResponseByHashQuery>;
export type ResponseByHashLazyQueryHookResult = ReturnType<typeof useResponseByHashLazyQuery>;
export type ResponseByHashQueryResult = Apollo.QueryResult<ResponseByHashQuery, ResponseByHashQueryVariables>;
export const OrganizationInfoDocument = gql`
    query OrganizationInfo($organizationId: ID!, $countryCode: String!) {
  Organization(organizationId: $organizationId, countryCode: $countryCode) {
    ...OrganizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;

/**
 * __useOrganizationInfoQuery__
 *
 * To run a query within a React component, call `useOrganizationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationInfoQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useOrganizationInfoQuery(baseOptions: Apollo.QueryHookOptions<OrganizationInfoQuery, OrganizationInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationInfoQuery, OrganizationInfoQueryVariables>(OrganizationInfoDocument, options);
      }
export function useOrganizationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationInfoQuery, OrganizationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationInfoQuery, OrganizationInfoQueryVariables>(OrganizationInfoDocument, options);
        }
export type OrganizationInfoQueryHookResult = ReturnType<typeof useOrganizationInfoQuery>;
export type OrganizationInfoLazyQueryHookResult = ReturnType<typeof useOrganizationInfoLazyQuery>;
export type OrganizationInfoQueryResult = Apollo.QueryResult<OrganizationInfoQuery, OrganizationInfoQueryVariables>;
export const OrganizationByHashDocument = gql`
    query OrganizationByHash($hashedId: String!, $countryCode: String!) {
  OrganizationByHash(hash: $hashedId, countryCode: $countryCode) {
    ...OrganizationFragment
  }
}
    ${OrganizationFragmentFragmentDoc}`;

/**
 * __useOrganizationByHashQuery__
 *
 * To run a query within a React component, call `useOrganizationByHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationByHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationByHashQuery({
 *   variables: {
 *      hashedId: // value for 'hashedId'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useOrganizationByHashQuery(baseOptions: Apollo.QueryHookOptions<OrganizationByHashQuery, OrganizationByHashQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationByHashQuery, OrganizationByHashQueryVariables>(OrganizationByHashDocument, options);
      }
export function useOrganizationByHashLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationByHashQuery, OrganizationByHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationByHashQuery, OrganizationByHashQueryVariables>(OrganizationByHashDocument, options);
        }
export type OrganizationByHashQueryHookResult = ReturnType<typeof useOrganizationByHashQuery>;
export type OrganizationByHashLazyQueryHookResult = ReturnType<typeof useOrganizationByHashLazyQuery>;
export type OrganizationByHashQueryResult = Apollo.QueryResult<OrganizationByHashQuery, OrganizationByHashQueryVariables>;
export const ResponseDocument = gql`
    query Response($token: String!, $countryCode: String!) {
  Response(token: $token, countryCode: $countryCode) {
    ...ResponseVersionFragment
  }
}
    ${ResponseVersionFragmentFragmentDoc}`;

/**
 * __useResponseQuery__
 *
 * To run a query within a React component, call `useResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResponseQuery({
 *   variables: {
 *      token: // value for 'token'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useResponseQuery(baseOptions: Apollo.QueryHookOptions<ResponseQuery, ResponseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResponseQuery, ResponseQueryVariables>(ResponseDocument, options);
      }
export function useResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResponseQuery, ResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResponseQuery, ResponseQueryVariables>(ResponseDocument, options);
        }
export type ResponseQueryHookResult = ReturnType<typeof useResponseQuery>;
export type ResponseLazyQueryHookResult = ReturnType<typeof useResponseLazyQuery>;
export type ResponseQueryResult = Apollo.QueryResult<ResponseQuery, ResponseQueryVariables>;
export const ResponseVersionsDocument = gql`
    query ResponseVersions($countryCode: String!, $documentId: ID!, $email: String!) {
  ResponseVersions(
    countryCode: $countryCode
    documentId: $documentId
    email: $email
  ) {
    ...ResponseVersionFragment
  }
}
    ${ResponseVersionFragmentFragmentDoc}`;

/**
 * __useResponseVersionsQuery__
 *
 * To run a query within a React component, call `useResponseVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResponseVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResponseVersionsQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResponseVersionsQuery(baseOptions: Apollo.QueryHookOptions<ResponseVersionsQuery, ResponseVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResponseVersionsQuery, ResponseVersionsQueryVariables>(ResponseVersionsDocument, options);
      }
export function useResponseVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResponseVersionsQuery, ResponseVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResponseVersionsQuery, ResponseVersionsQueryVariables>(ResponseVersionsDocument, options);
        }
export type ResponseVersionsQueryHookResult = ReturnType<typeof useResponseVersionsQuery>;
export type ResponseVersionsLazyQueryHookResult = ReturnType<typeof useResponseVersionsLazyQuery>;
export type ResponseVersionsQueryResult = Apollo.QueryResult<ResponseVersionsQuery, ResponseVersionsQueryVariables>;
export const StaffResponseVersionsDocument = gql`
    query StaffResponseVersions($countryCode: String!, $documentId: ID!) {
  StaffResponseVersions(countryCode: $countryCode, documentId: $documentId) {
    ...ResponseVersionFragment
  }
}
    ${ResponseVersionFragmentFragmentDoc}`;

/**
 * __useStaffResponseVersionsQuery__
 *
 * To run a query within a React component, call `useStaffResponseVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffResponseVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffResponseVersionsQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useStaffResponseVersionsQuery(baseOptions: Apollo.QueryHookOptions<StaffResponseVersionsQuery, StaffResponseVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaffResponseVersionsQuery, StaffResponseVersionsQueryVariables>(StaffResponseVersionsDocument, options);
      }
export function useStaffResponseVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaffResponseVersionsQuery, StaffResponseVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaffResponseVersionsQuery, StaffResponseVersionsQueryVariables>(StaffResponseVersionsDocument, options);
        }
export type StaffResponseVersionsQueryHookResult = ReturnType<typeof useStaffResponseVersionsQuery>;
export type StaffResponseVersionsLazyQueryHookResult = ReturnType<typeof useStaffResponseVersionsLazyQuery>;
export type StaffResponseVersionsQueryResult = Apollo.QueryResult<StaffResponseVersionsQuery, StaffResponseVersionsQueryVariables>;
export const EligibleTagsDocument = gql`
    query EligibleTags($documentId: ID!, $organizationId: ID!, $email: String!, $countryCode: String!) {
  EligibleTags(
    documentId: $documentId
    organizationId: $organizationId
    email: $email
    countryCode: $countryCode
  ) {
    ...TagFragment
  }
}
    ${TagFragmentFragmentDoc}`;

/**
 * __useEligibleTagsQuery__
 *
 * To run a query within a React component, call `useEligibleTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEligibleTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEligibleTagsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      organizationId: // value for 'organizationId'
 *      email: // value for 'email'
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useEligibleTagsQuery(baseOptions: Apollo.QueryHookOptions<EligibleTagsQuery, EligibleTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EligibleTagsQuery, EligibleTagsQueryVariables>(EligibleTagsDocument, options);
      }
export function useEligibleTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EligibleTagsQuery, EligibleTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EligibleTagsQuery, EligibleTagsQueryVariables>(EligibleTagsDocument, options);
        }
export type EligibleTagsQueryHookResult = ReturnType<typeof useEligibleTagsQuery>;
export type EligibleTagsLazyQueryHookResult = ReturnType<typeof useEligibleTagsLazyQuery>;
export type EligibleTagsQueryResult = Apollo.QueryResult<EligibleTagsQuery, EligibleTagsQueryVariables>;
export const TaxesAndFeesDocument = gql`
    query TaxesAndFees($organizationId: ID!, $passFeesToBuyer: Boolean!, $amount: Float!, $currency: String!) {
  TaxesAndFees(
    organizationId: $organizationId
    passFeesToBuyer: $passFeesToBuyer
    amount: $amount
    currency: $currency
  ) {
    ...TaxesAndFeesFragment
  }
}
    ${TaxesAndFeesFragmentFragmentDoc}`;

/**
 * __useTaxesAndFeesQuery__
 *
 * To run a query within a React component, call `useTaxesAndFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxesAndFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxesAndFeesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      passFeesToBuyer: // value for 'passFeesToBuyer'
 *      amount: // value for 'amount'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useTaxesAndFeesQuery(baseOptions: Apollo.QueryHookOptions<TaxesAndFeesQuery, TaxesAndFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxesAndFeesQuery, TaxesAndFeesQueryVariables>(TaxesAndFeesDocument, options);
      }
export function useTaxesAndFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaxesAndFeesQuery, TaxesAndFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxesAndFeesQuery, TaxesAndFeesQueryVariables>(TaxesAndFeesDocument, options);
        }
export type TaxesAndFeesQueryHookResult = ReturnType<typeof useTaxesAndFeesQuery>;
export type TaxesAndFeesLazyQueryHookResult = ReturnType<typeof useTaxesAndFeesLazyQuery>;
export type TaxesAndFeesQueryResult = Apollo.QueryResult<TaxesAndFeesQuery, TaxesAndFeesQueryVariables>;
export const TicketInventoryDocument = gql`
    query TicketInventory($countryCode: String!, $documentId: ID!, $ticketIds: [ID!]!) {
  TicketInventory(
    countryCode: $countryCode
    documentId: $documentId
    ticketIds: $ticketIds
  ) {
    ...TicketInventoryFragment
  }
}
    ${TicketInventoryFragmentFragmentDoc}`;

/**
 * __useTicketInventoryQuery__
 *
 * To run a query within a React component, call `useTicketInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketInventoryQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      documentId: // value for 'documentId'
 *      ticketIds: // value for 'ticketIds'
 *   },
 * });
 */
export function useTicketInventoryQuery(baseOptions: Apollo.QueryHookOptions<TicketInventoryQuery, TicketInventoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TicketInventoryQuery, TicketInventoryQueryVariables>(TicketInventoryDocument, options);
      }
export function useTicketInventoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketInventoryQuery, TicketInventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TicketInventoryQuery, TicketInventoryQueryVariables>(TicketInventoryDocument, options);
        }
export type TicketInventoryQueryHookResult = ReturnType<typeof useTicketInventoryQuery>;
export type TicketInventoryLazyQueryHookResult = ReturnType<typeof useTicketInventoryLazyQuery>;
export type TicketInventoryQueryResult = Apollo.QueryResult<TicketInventoryQuery, TicketInventoryQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    